#
msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2026-03-24 10:55+0200\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: hi\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: @lingui/cli\n"

#. placeholder {0}: item.maxSurge
#. placeholder {0}: item.maximum
#. placeholder {0}: item.minimum
#. placeholder {1}: item.maxSurge
#. placeholder {1}: item.maximum
#. placeholder {1}: item.minimum
#: src/modules/services/FailoverNodeSelect.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "{0} {1, plural, one {node} other {nodes}}"
msgstr "{0} {1, plural, one {नोड} other {नोड}}"

#. placeholder {0}: uploadStats.uploadedFiles
#. placeholder {1}: uploadStats.totalFiles
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{0} of {1} files uploaded"
msgstr "{1} में से {0} फ़ाइलें अपलोड हुईं"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{name} will be deleted permanently."
msgstr "{name} स्थायी रूप से हटा दिया जाएगा।"

#: src/modules/storage/StorageList.tsx
msgid "{number_of_buckets, plural, one {bucket} other {buckets}}"
msgstr "{number_of_buckets, plural, one {बकेट} other {बकेट}}"

#. {resourceTypeName} is eg. 'virtual machine' or 'billing account'
#: src/modules/api/resourceTypeException.tsx
msgid "{resourceTypeName} with ID {id} not found"
msgstr "ID {id} वाला {resourceTypeName} नहीं मिला"

#. ONLY:bn
#: src/styles/tenbyte/theme.tsx
msgid "<0><1>Individual/Proprietor: NID, Passport, or Driver's License.</1><2>Company/Corporate: Trade License.</2><3>Financial & Legal: Tax Identification Number (TIN), VAT Certificate.</3></0>"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "1 bare metal server"
msgstr "1 बेयर मेटल सर्वर"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 day"
msgstr "1 दिन"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 hour"
msgstr "1 घंटा"

#: src/modules/billing/omise/OmisePaymentForm.tsx
msgid "10 digit TrueMoney mobile number starting with 0"
msgstr "0 से शुरू होने वाला 10 अंकों का TrueMoney मोबाइल नंबर"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "3 days"
msgstr "3 दिन"

#: src/modules/compute/VmView.tsx
msgid "4 weeks"
msgstr "4 सप्ताह"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "6 hours"
msgstr "6 घंटे"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "7 days"
msgstr "7 दिन"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "A discount has been applied for all services under this billing account."
msgstr "इस बिलिंग खाते के अंतर्गत सभी सेवाओं पर छूट लागू की गई है।"

#: src/modules/compute/VmCreate.tsx
msgid "A user account will be created with this username. It can be used to log in to the VM. Can contain ASCII letters, digits, underscores and hyphens. Must start with a letter or underscore. Maximum length is 25 characters."
msgstr "इस उपयोगकर्ता नाम के साथ एक उपयोगकर्ता खाता बनाया जाएगा। इसका उपयोग VM में लॉग इन करने के लिए किया जा सकता है। इसमें ASCII अक्षर, अंक, अंडरस्कोर और हाइफ़न हो सकते हैं। इसकी शुरुआत किसी अक्षर या अंडरस्कोर से होनी चाहिए। अधिकतम लंबाई 25 वर्ण है।"

#: src/modules/network/NetworkCreate.tsx
msgid "A virtual private cloud (VPC) is a private network interface for collections of your resources. VPC network is available at no additional cost."
msgstr "वर्चुअल प्राइवेट क्लाउड (VPC) आपके संसाधनों के समूहों के लिए एक निजी नेटवर्क इंटरफ़ेस है। VPC नेटवर्क बिना किसी अतिरिक्त लागत के उपलब्ध है।"

#: src/modules/access/AcceptInvitationModal.tsx
#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept"
msgstr "स्वीकार करें"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept invitation"
msgstr "आमंत्रण स्वीकार करें"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/user/ProfileView.tsx
msgid "Accepted"
msgstr "स्वीकार किया गया"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accepting this access invitation will grant you permission to act as \"{name}\" and perform all operations on behalf of the user."
msgstr "इस एक्सेस आमंत्रण को स्वीकार करने पर आपको \"{name}\" के रूप में कार्य करने और उपयोगकर्ता की ओर से सभी कार्रवाइयाँ करने की अनुमति मिल जाएगी।"

#. Label for dropdown menu that has options related to file sharing and permissions. | POS: Noun
#. Title for section that contains credentials to connect to a database
#: src/modules/access/AccessList.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/Access.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Access"
msgstr "एक्सेस"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Access credentials"
msgstr "प्रवेश विवरण"

#: src/modules/api/resourceTypes.tsx
msgid "Access delegation"
msgstr "एक्सेस डेलीगेशन"

#: src/modules/user/ProfileView.tsx
msgid "Access group"
msgstr "एक्सेस समूह"

#: src/modules/user/InvitationNotice.tsx
msgid "Access has been shared with you"
msgstr "आपके साथ एक्सेस साझा किया गया है"

#: src/modules/api/resourceTypes.tsx
msgid "Access invitation"
msgstr "एक्सेस निमंत्रण"

#. placeholder {0}: item.access_owner
#: src/modules/user/InvitationNotice.tsx
msgid "Access invitation from {0} is pending"
msgstr "{0} से एक्सेस आमंत्रण लंबित है"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Access key ID"
msgstr "एक्सेस कुंजी ID"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access name"
msgstr "एक्सेस का नाम"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Access scope"
msgstr "एक्सेस दायरा"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access type"
msgstr "एक्सेस का प्रकार"

#. Dialog title
#: src/modules/user/ActAsModal.tsx
msgid "Access user"
msgstr "उपयोगकर्ता तक पहुँचें"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
#: src/modules/billing/NoValidBillingAccountNotice.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account details are being validated."
msgstr "खाते के विवरण का सत्यापन किया जा रहा है।"

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "Account details must be validated"
msgstr "खाते के विवरण का सत्यापन आवश्यक है"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Account ID"
msgstr "खाता ID"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account name"
msgstr "खाते का नाम"

#. Menu item to impersonate another user
#: src/modules/user/ActAsModal.tsx
#: src/modules/user/UserMenu.tsx
msgid "Act as"
msgstr "के रूप में कार्य करें"

#. placeholder {0}: impersonation.access_owner
#: src/modules/user/ImpersonateTopItem.tsx
msgid "Acting as <0>{0}</0>"
msgstr "<0>{0}</0> के रूप में कार्यरत"

#. Login page title when email verification is required
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Action required"
msgstr "कार्रवाई आवश्यक है"

#. Billing account status
#. Disk status
#. Service status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Active"
msgstr "सक्रिय"

#: src/modules/storage/StorageCreate.tsx
msgid "Actual cost of your storage is calculated hourly based on your actual usage, no upfront payments. For every started GB the price is rounded up to next whole GB."
msgstr "आपके स्टोरेज की वास्तविक लागत आपके वास्तविक उपयोग के आधार पर प्रति घंटे गणना की जाती है, कोई अग्रिम भुगतान नहीं है। प्रत्येक शुरू किए गए GB के लिए कीमत को अगले पूर्ण GB तक ऊपर की ओर पूर्णांकित किया जाता है।"

#: src/modules/services/ServiceView.tsx
msgid "Actual price is determined by compute and storage usage. Persistent volumes of hibernated clusters will still be charged for. See billing account current usage for more detailed information."
msgstr "वास्तविक मूल्य कंप्यूट और स्टोरेज उपयोग के आधार पर निर्धारित होता है। हाइबरनेट किए गए क्लस्टरों के पर्सिस्टेंट वॉल्यूम के लिए भी शुल्क लिया जाएगा। अधिक विस्तृत जानकारी के लिए बिलिंग खाते का वर्तमान उपयोग देखें।"

#. Add a new row; Button action
#: src/components/EditableList.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add"
msgstr "जोड़ें"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Add a a payment method that supports automated top up."
msgstr "स्वचालित टॉप अप का समर्थन करने वाली भुगतान विधि जोड़ें।"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Add additional disk"
msgstr "अतिरिक्त डिस्क जोड़ें"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one forwarding rule"
msgstr "कम से कम एक फ़ॉरवर्डिंग नियम जोड़ें"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one target server"
msgstr "कम से कम एक लक्ष्य सर्वर जोड़ें"

#: src/modules/compute/VmCreate.tsx
msgid "Add custom configuration for the virtual machine"
msgstr "वर्चुअल मशीन के लिए कस्टम विन्यास जोड़ें"

#: src/modules/user/ProfileView.tsx
msgid "Add first name"
msgstr "पहला नाम जोड़ें"

#: src/modules/services/IpWhitelist.tsx
msgid "Add IP"
msgstr "IP जोड़ें"

#: src/modules/user/ProfileView.tsx
msgid "Add last name"
msgstr "अंतिम नाम जोड़ें"

#: src/components/table/DetailsTableName.tsx
msgid "Add name"
msgstr "नाम जोड़ें"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add new payment method..."
msgstr "नई भुगतान विधि जोड़ें..."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Add new reservation"
msgstr "नया आरक्षण जोड़ें"

#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add new rule"
msgstr "नया नियम जोड़ें"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add node"
msgstr "नोड जोड़ें"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Add node pool"
msgstr "नोड पूल जोड़ें"

#: src/modules/billing/ActionButtons.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add payment method"
msgstr "भुगतान विधि जोड़ें"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Add payment method later"
msgstr "भुगतान विधि बाद में जोड़ें"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "Add rule"
msgstr "नियम जोड़ें"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Add SSH key"
msgstr "SSH कुंजी जोड़ें"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Add sub-interface"
msgstr "उप-इंटरफ़ेस जोड़ें"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add target server"
msgstr "लक्षित सर्वर जोड़ें"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "Add user"
msgstr "उपयोगकर्ता जोड़ें"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Add users"
msgstr "उपयोगकर्ता जोड़ें"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Adding payment method failed"
msgstr "भुगतान विधि जोड़ना विफल हुआ"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/network/NetworkList.tsx
msgid "Address"
msgstr "पता"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Address line 2"
msgstr "पता पंक्ति 2"

#. Link to administrative user interface
#: src/modules/user/UserMenu.tsx
msgid "Admin view"
msgstr "प्रशासक दृश्य"

#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Administrator"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Administrator action"
msgstr ""

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/WTabs.tsx
msgid "All"
msgstr "सभी"

#. A firewall rule that applies to every source or destination IP address
#: src/modules/network/firewall/firewallLabels.tsx
msgid "All IP addresses"
msgstr "सभी IP पते"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "All permissions"
msgstr "सभी अनुमतियाँ"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All TCP"
msgstr "सभी TCP"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All UDP"
msgstr "सभी UDP"

#: src/modules/api/resourceTypes.tsx
msgid "Allocate a floating IP and start managing your network."
msgstr "एक फ़्लोटिंग IP आवंटित करें और अपने नेटवर्क का प्रबंधन शुरू करें।"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Allocated"
msgstr "आवंटित"

#: src/modules/network/NetworkCreate.tsx
msgid "Allocating a new IPv4 address allows you to assign it to one of your existing resources or reserve it for later use."
msgstr "नया IPv4 पता आवंटित करने से आप इसे अपने मौजूदा संसाधनों में से किसी एक को असाइन कर सकते हैं या बाद में उपयोग के लिए आरक्षित रख सकते हैं।"

#: src/modules/login/Login.tsx
msgid "Already have an account?"
msgstr "क्या आपके पास पहले से खाता है?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Amount"
msgstr "राशि"

#. Field label for reservation upfront cost
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Amount billed upfront"
msgstr "अग्रिम रूप से बिल की गई राशि"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Amount is too low"
msgstr "राशि बहुत कम है"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Amount should be positive"
msgstr "राशि शून्य से अधिक होनी चाहिए"

#: src/modules/billing/AutomatedTopUpModal.tsx
msgid "Amount should not be less than than minimum top up"
msgstr "राशि न्यूनतम टॉप अप से कम नहीं होनी चाहिए"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "An active billing account is needed to create resources."
msgstr "संसाधन बनाने के लिए एक सक्रिय बिलिंग खाता आवश्यक है।"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "An active billing account is needed to use this feature."
msgstr "इस सुविधा का उपयोग करने के लिए एक सक्रिय बिलिंग खाता आवश्यक है।"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
msgid "An e-mail with instructions has been sent to you."
msgstr "निर्देशों वाला एक ई-मेल आपको भेज दिया गया है।"

#: src/components/modal/WModal.tsx
#: src/components/sidebar/ListErrorBoundary.tsx
msgid "An error happened"
msgstr "एक त्रुटि हुई"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/firewall/ruleSpec.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Any"
msgstr "कोई भी"

#: src/modules/access/AccessList.tsx
#: src/modules/dashboard/WelcomeBlock.tsx
#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "API"
msgstr "API"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "API documentation"
msgstr "API प्रलेखन"

#: src/modules/api/resourceTypes.tsx
msgid "API token"
msgstr "API टोकन"

#: src/modules/compute/labels.tsx
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "App catalog"
msgstr "ऐप कैटलॉग"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Appearance"
msgstr "रूप-रंग"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Apply for payment by invoice"
msgstr "इनवॉइस द्वारा भुगतान के लिए आवेदन करें"

#: src/modules/compute/SubInterfaceDeleteModal.tsx
msgid "Are you sure you want to delete sub-interface with uuid {ifUuid}?"
msgstr "क्या आप वाकई uuid {ifUuid} वाले उप-इंटरफ़ेस को हटाना चाहते हैं?"

#: src/modules/compute/SshKeyDeleteModal.tsx
msgid "Are you sure you want to delete the public key \"{name}\"?"
msgstr "क्या आप वाकई सार्वजनिक कुंजी \"{name}\" को हटाना चाहते हैं?"

#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Are you sure you want to log out?"
msgstr "क्या आप वाकई लॉग आउट करना चाहते हैं?"

#: src/modules/network/NetworkCreate.tsx
msgid "Assign to"
msgstr "को असाइन करें"

#. State of IP address, attached to a resource such as a virtual machine
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
msgid "Assigned"
msgstr "आवंटित"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Assigned to"
msgstr "को असाइन किया गया"

#: src/modules/access/AccessCreate.tsx
msgid "At least one email is required"
msgstr "कम से कम एक ईमेल आवश्यक है"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "At least one IP is required"
msgstr "कम से कम एक IP आवश्यक है"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "At least one node pool must have autoscaler minimum value as 1 or more."
msgstr "कम से कम एक नोड पूल में ऑटोस्केलर का न्यूनतम मान 1 या उससे अधिक होना चाहिए।"

#: src/modules/compute/VmView.tsx
msgid "Attach firewall"
msgstr "फ़ायरवॉल संलग्न करें"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Attach resource"
msgstr "संसाधन संलग्न करें"

#: src/modules/disks/DiskList.tsx
msgid "Attached"
msgstr "जुड़ा हुआ"

#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
msgid "Attached to"
msgstr "इससे जुड़ा है"

#. Explanation: Switching the color schema automatically. |Alternatives: 'Automatic'
#: src/modules/main/ColorSchemeMenu.tsx
msgid "Auto"
msgstr "स्वतः"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Auto update"
msgstr "स्वचालित अपडेट"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Automated payment"
msgstr "स्वचालित भुगतान"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automated top up"
msgstr "स्वचालित टॉप अप"

#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your service. Backups will be stored for 7 days, meaning you will have 7 latest backups."
msgstr "स्वचालित सिस्टम-स्तरीय बैकअप सक्षम हैं। अपनी सेवा को पुनर्स्थापित करने के लिए बैकअप इमेज का उपयोग करें। बैकअप 7 दिनों तक संग्रहीत रहेंगे, अर्थात आपके पास 7 नवीनतम बैकअप उपलब्ध होंगे।"

#: src/modules/compute/VmView.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your virtual machine or create a new virtual machine from the backup with modified size parameters."
msgstr "स्वचालित सिस्टम-स्तरीय बैकअप सक्षम हैं। अपनी वर्चुअल मशीन को पुनर्स्थापित करने या संशोधित आकार पैरामीटर के साथ बैकअप से नई वर्चुअल मशीन बनाने के लिए बैकअप इमेज का उपयोग करें।"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Automatic updates will not update preview versions."
msgstr "स्वचालित अपडेट प्रीव्यू संस्करणों को अपडेट नहीं करेंगे।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automatically top up (min. <0/>)"
msgstr "स्वचालित रूप से टॉप अप करें (न्यूनतम <0/>)"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler max."
msgstr "ऑटोस्केलर अधिकतम"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler min."
msgstr "ऑटोस्केलर न्यूनतम"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Available"
msgstr "उपलब्ध"

#: src/modules/services/ServiceView.tsx
msgid "Awake"
msgstr "सक्रिय"

#. Button action
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Back"
msgstr "वापस"

#: src/modules/user/ImpersonateTopItem.tsx
#: src/modules/user/UserMenu.tsx
msgid "Back to your account"
msgstr "अपने खाते पर वापस जाएँ"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
msgid "Backups"
msgstr "बैकअप"

#. Table column: billing account balance when the change happened
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance"
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Balance became negative"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Balance became positive"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance history"
msgstr "शेष राशि का इतिहास"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Balance negative for {days, plural, one {# day} other {# days}} (limit: {threshold, plural, one {# day} other {# days}})"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Balance negative for too long"
msgstr ""

#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/metal/MetalList.tsx
msgid "Bare metal"
msgstr "बेयर मेटल"

#: src/modules/api/resourceTypes.tsx
msgid "Bare metal server"
msgstr "बेयर मेटल सर्वर"

#: src/modules/billing/BaseCurrencyField.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Base currency"
msgstr "मूल मुद्रा"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Begin your billing account validation process."
msgstr "अपनी बिलिंग खाता सत्यापन प्रक्रिया शुरू करें।"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Below is an example of how to configure this sub-interface on a Linux server."
msgstr "नीचे Linux सर्वर पर इस उप-इंटरफ़ेस को कॉन्फ़िगर करने का एक उदाहरण दिया गया है।"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Below the top-up threshold"
msgstr ""

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Billed"
msgstr "बिल किया गया"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Billing"
msgstr "बिलिंग"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/table/DetailsTableBillingAccount.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/forms/BillingAccountField.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Billing account"
msgstr "बिलिंग खाता"

#. Price list annotation
#: src/modules/pricing/PricingModal.tsx
msgid "Billing account \"{title}\" has discount {discount_percentage}%"
msgstr "बिलिंग खाता \"{title}\" पर {discount_percentage}% की छूट है"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account created"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account deleted"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Billing account is limited"
msgstr "बिलिंग खाता सीमित है"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Billing account name"
msgstr "बिलिंग खाते का नाम"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Billing account override"
msgstr "बिलिंग खाता ओवरराइड"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account reactivated"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account suspended"
msgstr "बिलिंग खाता निलंबित है"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account updated"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account validation"
msgstr ""

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Billing account validation was rejected"
msgstr "बिलिंग खाते का सत्यापन अस्वीकार कर दिया गया"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Billing account waiting for validation"
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Billing accounts"
msgstr "बिलिंग खाते"

#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Billing cycle"
msgstr "बिलिंग चक्र"

#: src/modules/disks/disk/DiskView.tsx
msgid "Boot"
msgstr "बूट"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Boot from ISO medium"
msgstr "ISO माध्यम से बूट करें"

#. Virtual machine choice: UEFI or BIOS
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Boot mode"
msgstr "बूट मोड"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Booting is only possible when the virtual machine is stopped."
msgstr "बूट करना केवल तभी संभव है जब वर्चुअल मशीन बंद हो।"

#. {payment method} provided by {payment gateway name}
#: src/modules/billing/utils.tsx
msgid "by {gatewayName}"
msgstr "{gatewayName} द्वारा"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "By continuing with the top up you agree to the <0>Terms & Conditions</0>, <1>Privacy Policy</1> & <2>Refund Policy</2>."
msgstr "टॉप अप जारी रखकर आप <0>नियम एवं शर्तों</0>, <1>गोपनीयता नीति</1> और <2>रिफंड नीति</2> से सहमत होते हैं।"

#: src/modules/compute/VmView.tsx
msgid "By disabling backups there will not be any further automatic backups made from your virtual machine. Backups done by this point will be kept as is and you can still use them. You can enable backups again whenever needed."
msgstr "बैकअप अक्षम करने पर आपकी वर्चुअल मशीन से आगे कोई स्वचालित बैकअप नहीं बनाया जाएगा। अब तक बनाए गए बैकअप जैसे हैं वैसे ही रखे जाएंगे और आप उनका उपयोग फिर भी कर सकेंगे। आवश्यकता होने पर आप कभी भी बैकअप फिर से सक्षम कर सकते हैं।"

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Global”, all resources under this user account can be accessed. Exercise caution when selecting “Global” scope."
msgstr "“वैश्विक” चुनने पर इस उपयोगकर्ता खाते के अंतर्गत आने वाले सभी संसाधनों तक पहुँचा जा सकता है। “वैश्विक” दायरा चुनते समय सावधानी बरतें।"

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Restricted”, access will be limited to resources belonging to the selected billing account."
msgstr "“सीमित” चुनने पर एक्सेस केवल चुने गए बिलिंग खाते से संबंधित संसाधनों तक सीमित रहेगा।"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "By signing up, you agree to the <0>Terms of Service</0>"
msgstr "साइन अप करके, आप <0>सेवा की शर्तों</0> से सहमत होते हैं"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Campaign code"
msgstr "अभियान कोड"

#: src/modules/dashboard/UserAccess.tsx
msgid "Can access me"
msgstr "जो मुझ तक पहुँच सकते हैं"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Cancel"
msgstr "रद्द करें"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Cancel uploads"
msgstr "अपलोड रद्द करें"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Cancelled"
msgstr "रद्द किया गया"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Card number"
msgstr "कार्ड नंबर"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Card verification failed"
msgstr "कार्ड सत्यापन विफल हुआ"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change"
msgstr "बदलें"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change password"
msgstr "पासवर्ड बदलें"

#: src/modules/login/Login.tsx
msgid "Change your password by clicking the verification link we just sent to your inbox."
msgstr "अभी आपके इनबॉक्स में भेजे गए सत्यापन लिंक पर क्लिक करके अपना पासवर्ड बदलें।"

#. Table column: who changed the billing account status
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Changed by"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Changing the password failed"
msgstr "पासवर्ड बदलना विफल रहा"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Changing the password is only possible when the virtual machine is running."
msgstr "पासवर्ड बदलना केवल तभी संभव है जब वर्चुअल मशीन चालू हो।"

#: src/modules/billing/forms/BillingAccountField.tsx
msgid "Choose a billing account for your new resource to consolidate your resources under a suitable payment method."
msgstr "अपने नए संसाधन के लिए एक बिलिंग खाता चुनें, ताकि आपके संसाधन एक उपयुक्त भुगतान विधि के अंतर्गत समेकित रहें।"

#: src/modules/access/AccessCreate.tsx
msgid "Choose a billing account you wish to share access to"
msgstr "वह बिलिंग खाता चुनें जिसके लिए आप एक्सेस साझा करना चाहते हैं"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose a resource to assign the IP to or leave it unassigned. You can always assign the IP to a suitable resource later"
msgstr "IP को असाइन करने के लिए कोई संसाधन चुनें या इसे अनअसाइन ही रहने दें। आप बाद में भी IP को किसी उपयुक्त संसाधन को असाइन कर सकते हैं।"

#: src/modules/disks/DiskCreate.tsx
msgid "Choose a virtual machine to attach the disk to, or leave it detached and connect it to a virtual machine later."
msgstr "डिस्क संलग्न करने के लिए एक वर्चुअल मशीन चुनें, या इसे अलग ही रहने दें और बाद में किसी वर्चुअल मशीन से कनेक्ट करें।"

#: src/modules/compute/VmCreate.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "Choose a VPC network for your resource from already existing one or create a new private network."
msgstr "अपने संसाधन के लिए पहले से मौजूद VPC नेटवर्क चुनें या एक नया निजी नेटवर्क बनाएँ।"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Choose billing account"
msgstr "बिलिंग खाता चुनें"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Choose method"
msgstr "विधि चुनें"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose the VPC network the target servers are in."
msgstr "वह VPC नेटवर्क चुनें जिसमें लक्ष्य सर्वर हैं।"

#: src/modules/compute/VmCreate.tsx
msgid "Choose UEFI if the VM you are importing requires it."
msgstr "यदि आपके द्वारा इंपोर्ट की जा रही VM को UEFI की आवश्यकता है, तो UEFI चुनें।"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "City"
msgstr "शहर"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Cleaning"
msgstr "सफाई"

#. Billing account restriction level | POS: Adjective
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Clear"
msgstr ""

#: src/modules/notifications/NotificationMenu.tsx
msgid "Clear all"
msgstr "सभी साफ़ करें"

#. Button: Remove the over-ride of the billing account for this bucket
#: src/modules/storage/bucket/BucketView.tsx
msgid "Clear override"
msgstr "ओवरराइड हटाएँ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Clear uploads"
msgstr "अपलोड सूची साफ़ करें"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Click the button to connect to PayPal."
msgstr "PayPal से कनेक्ट करने के लिए बटन पर क्लिक करें।"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone"
msgstr "प्रतिलिपि बनाएँ"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone resource"
msgstr "संसाधन की प्रतिलिपि बनाएँ"

#. Button action
#: src/components/modal/WModal.tsx
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/access/delegation/AddImpersonationForm.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
msgid "Close"
msgstr "बंद करें"

#. Label for an authentication error code
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Code:"
msgstr "कोड:"

#. Server has been pre-paid
#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Committed"
msgstr "प्रतिबद्ध"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Company name"
msgstr "कंपनी का नाम"

#: src/styles/dataxion/theme.tsx
msgid "Company RNE number"
msgstr "कंपनी का RNE नंबर"

#: src/modules/access/token/TokenView.tsx
msgid "Comprehensive API manual with code samples is available here:"
msgstr "कोड उदाहरणों सहित विस्तृत API मैनुअल यहाँ उपलब्ध है:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Compute"
msgstr "कंप्यूट"

#. Alternative: Configure a custom subnet range
#: src/modules/network/NetworkCreate.tsx
msgid "Configure my own"
msgstr "स्वयं कॉन्फ़िगर करें"

#: src/modules/login/Login.tsx
msgid "Confirm email"
msgstr "ईमेल की पुष्टि करें"

#: src/modules/compute/PasswordFields.tsx
msgid "Confirm password"
msgstr "पासवर्ड की पुष्टि करें"

#: src/modules/login/Login.tsx
msgid "Confirm your email address by clicking the verification link we just sent to your inbox."
msgstr "अभी आपके इनबॉक्स में भेजे गए सत्यापन लिंक पर क्लिक करके अपने ईमेल पते की पुष्टि करें।"

#: src/components/modal/DeleteModal.tsx
#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Confirmation"
msgstr "पुष्टि"

#: src/modules/compute/WVnc.tsx
msgid "Connect"
msgstr "कनेक्ट करें"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Connect to PayPal first"
msgstr "पहले PayPal से कनेक्ट करें"

#: src/modules/compute/WVnc.tsx
msgid "Connecting"
msgstr "कनेक्ट किया जा रहा है"

#: src/modules/billing/progressLabels.tsx
msgid "Connecting payment method"
msgstr "भुगतान विधि जोड़ी जा रही है"

#. Title for section that contains credentials to connect to a database
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/ServiceView.tsx
msgid "Connection details"
msgstr "कनेक्शन विवरण"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's name"
msgstr "संपर्क व्यक्ति का नाम"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's phone"
msgstr "संपर्क व्यक्ति का फ़ोन"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/support/ContactSupportButton.tsx
msgid "Contact support"
msgstr "सहायता से संपर्क करें"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
#: src/modules/login/ConsentForm.tsx
#: src/modules/login/Login.tsx
msgid "Continue"
msgstr "जारी रखें"

#: src/components/ClipBoardTooltip.tsx
msgid "Copied!"
msgstr "कॉपी किया गया!"

#. Full form: Copy to clipboard
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Copy"
msgstr "कॉपी करें"

#: src/modules/services/Access.tsx
msgid "Copy config to clipboard"
msgstr "कॉन्फ़िग को क्लिपबोर्ड पर कॉपी करें"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Copy public URL"
msgstr "सार्वजनिक URL कॉपी करें"

#: src/components/ClipBoardTooltip.tsx
msgid "Copy to clipboard"
msgstr "क्लिपबोर्ड में कॉपी करें"

#. All the main resources and services offered by the cloud platform
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Core services"
msgstr "मुख्य सेवाएँ"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Country"
msgstr "देश"

#. Part of address
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "County"
msgstr "ज़िला"

#: src/modules/compute/MetricsGrid.tsx
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/compute/VmSizeSelect.tsx
msgid "CPU"
msgstr "CPU"

#. Button: Create a new resource
#: src/components/forms/CreateFormAction.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Create"
msgstr "बनाएँ"

#. Button: Create new billing account
#: src/modules/dashboard/BillingAccounts.tsx
msgctxt "Should be short (1-3 words)"
msgid "Create"
msgstr "बनाएँ"

#: src/modules/billing/BillingList.tsx
msgid "Create a billing account first, then you can start creating resources."
msgstr "पहले बिलिंग खाता बनाएँ, फिर आप संसाधन बनाना शुरू कर सकते हैं।"

#: src/modules/api/resourceTypes.tsx
msgid "Create a dedicated bare metal server and run your application with maximum performance."
msgstr "एक समर्पित बेयर मेटल सर्वर बनाएँ और अपने एप्लिकेशन को अधिकतम प्रदर्शन के साथ चलाएँ।"

#: src/modules/error/ErrorFallback.tsx
msgid "Create a new {resourceTypeName}"
msgstr "नया {resourceTypeName} बनाएँ"

#: src/modules/access/AccessList.tsx
msgid "Create a new access to enable other users or systems to perform actions with this {siteName} account."
msgstr "इस {siteName} खाते के साथ अन्य उपयोगकर्ताओं या सिस्टमों को कार्रवाइयाँ करने की अनुमति देने के लिए नया एक्सेस बनाएँ।"

#: src/modules/disks/DiskList.tsx
msgid "Create a new disk and start storing your data."
msgstr "नई डिस्क बनाएँ और अपना डेटा स्टोर करना शुरू करें।"

#: src/modules/compute/VmList.tsx
#: src/modules/metal/MetalList.tsx
msgid "Create a new resource and get your services running in minutes."
msgstr "नया संसाधन बनाएँ और अपनी सेवाएँ कुछ ही मिनटों में चालू करें।"

#: src/modules/network/NetworkList.tsx
msgid "Create a new resource and start managing your network."
msgstr "नया संसाधन बनाएँ और अपने नेटवर्क का प्रबंधन शुरू करें।"

#: src/modules/services/ServicesList.tsx
msgid "Create a new service and get it running in minutes."
msgstr "नई सेवा बनाएँ और उसे कुछ ही मिनटों में चालू करें।"

#: src/modules/api/resourceTypes.tsx
msgid "Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "एक नया स्टोरेज खाता बनाएँ, कुछ बकेट बनाएँ और अपने डेटा को स्केलेबल तरीके से संग्रहीत करना शुरू करें - जितना बढ़े, उतना भुगतान करें।"

#: src/modules/storage/StorageList.tsx
msgid "Create a new storage account, create some buckets and start storing your data."
msgstr "एक नया स्टोरेज खाता बनाएँ, कुछ बकेट बनाएँ और अपना डेटा संग्रहीत करना शुरू करें।"

#: src/modules/api/resourceTypes.tsx
msgid "Create a new Virtual Machine or choose something from the App Catalog to get your services running in minutes."
msgstr "नई वर्चुअल मशीन बनाएँ या अपनी सेवाओं को कुछ ही मिनटों में चालू करने के लिए ऐप कैटलॉग से कुछ चुनें।"

#: src/modules/api/resourceTypes.tsx
msgid "Create a personal Virtual Private Cloud (VPC) and start managing your networks."
msgstr "अपना व्यक्तिगत वर्चुअल प्राइवेट क्लाउड (VPC) बनाएँ और अपने नेटवर्क प्रबंधित करना शुरू करें।"

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "Create a public IPv4 address for the resource"
msgstr "संसाधन के लिए एक सार्वजनिक IPv4 पता बनाएँ"

#: src/modules/disks/DiskCreate.tsx
msgid "Create additional storage for your workloads. Configure the disk and attach it to a virtual machine now or later."
msgstr "अपने वर्कलोड के लिए अतिरिक्त स्टोरेज बनाएँ। डिस्क कॉन्फ़िगर करें और इसे अभी या बाद में किसी वर्चुअल मशीन से संलग्न करें।"

#: src/modules/login/Login.tsx
msgid "Create an account"
msgstr "खाता बनाएँ"

#: src/modules/api/resourceTypes.tsx
msgid "Create an API Token to use our API."
msgstr "हमारे API का उपयोग करने के लिए API टोकन बनाएँ।"

#. placeholder {0}: getResourceTypeName(type)
#: src/components/loading/Loading.tsx
msgid "Create another {0}"
msgstr "एक और {0} बनाएँ"

#: src/components/forms/CreateBillingAccount.tsx
msgid "Create billing account"
msgstr "बिलिंग खाता बनाएँ"

#: src/components/forms/CreateBillingAccount.tsx
#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/CoreServices.tsx
#: src/modules/dashboard/ManagedServices.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/StorageCreate.tsx
#: src/modules/storage/StorageList.tsx
msgid "Create new"
msgstr "नया बनाएँ"

#. Created at timestamp
#: src/modules/access/AccessList.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created"
msgstr "बनाया गया"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created at"
msgstr "बनाया गया"

#: src/modules/access/AccessList.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServicesList.tsx
msgid "Created date"
msgstr "बनाने की तारीख"

#: src/modules/compute/ModalHeaderBlock.tsx
msgid "Created from"
msgstr "से बनाया गया"

#. Virtual machine status
#: src/components/loading/Loading.tsx
#: src/modules/compute/statusLabels.tsx
msgid "Creating"
msgstr "बनाया जा रहा है"

#: src/modules/access/AccessCreate.tsx
msgid "Creating an access by API Token gives you a key to use with our API."
msgstr "API टोकन द्वारा एक्सेस बनाने पर आपको हमारी API के साथ उपयोग करने के लिए एक कुंजी मिलती है।"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Credit"
msgstr "क्रेडिट"

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Credit adjustment"
msgstr ""

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Credit is added to this billing account automatically once the payment is received. Make sure the billing account ID is entered correctly."
msgstr ""

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Credit Note {id}"
msgstr "क्रेडिट नोट {id}"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Current"
msgstr "वर्तमान"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Current billing cycle"
msgstr "वर्तमान बिलिंग चक्र"

#. Explanation: Restoring a snapshot or backup will delete the current state of the virtual machine.
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Current changes will be discarded."
msgstr "वर्तमान परिवर्तन त्याग दिए जाएँगे।"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Current usage"
msgstr "वर्तमान उपयोग"

#: src/modules/compute/VmSizeSelect.tsx
msgid "Currently not available"
msgstr "फ़िलहाल उपलब्ध नहीं है"

#. Custom operating system
#: src/modules/compute/os/OsInfo.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Custom"
msgstr "कस्टम"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Custom ISO image"
msgstr "कस्टम ISO इमेज"

#: src/modules/support/WChatProvider.tsx
msgid "Customer support"
msgstr "ग्राहक सहायता"

#: src/modules/billing/payment_forms/labels.tsx
msgid "CVC"
msgstr "CVC"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Dark"
msgstr "गहरा"

#: src/modules/dashboard/Dashboard.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Dashboard"
msgstr "डैशबोर्ड"

#: src/modules/location/LocationDetail.tsx
msgid "Data center where resource is located"
msgstr "डेटा सेंटर जहाँ संसाधन स्थित है"

#: src/modules/location/LocationField.tsx
msgid "Data center where the resource will be created."
msgstr "वह डेटा सेंटर जहाँ संसाधन बनाया जाएगा।"

#: src/components/forms/WSelect.tsx
msgid "Data missing"
msgstr "डेटा उपलब्ध नहीं है"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Date"
msgstr "तिथि"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Declined / Suspended"
msgstr "अस्वीकृत / निलंबित"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/dashboard/BillingAccounts.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Default"
msgstr "डिफ़ॉल्ट"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Default level for post-payment billing accounts"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Delegate access to"
msgstr "एक्सेस डेलीगेट करें"

#: src/modules/api/resourceTypes.tsx
msgid "Delegate access to your user or billing account so trusted users can manage your resources."
msgstr "अपने यूज़र या बिलिंग खाते का एक्सेस डेलीगेट करें ताकि विश्वसनीय उपयोगकर्ता आपके संसाधनों का प्रबंधन कर सकें।"

#: src/modules/user/ProfileView.tsx
msgid "Delegate new access"
msgstr "नया एक्सेस डेलीगेट करें"

#: src/modules/access/AccessCreate.tsx
msgid "Delegating access to a chosen trusted user enables the user to act as you and perform all operations on behalf of your user or billing account."
msgstr "किसी चुने हुए विश्वसनीय उपयोगकर्ता को एक्सेस डेलीगेट करने से वह उपयोगकर्ता आपके रूप में कार्य कर सकता है और आपके उपयोगकर्ता या बिलिंग खाते की ओर से सभी कार्रवाइयाँ कर सकता है।"

#: src/components/button/DeleteButton.tsx
#: src/components/modal/DeleteModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Delete"
msgstr "हटाएँ"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Delete floating IP"
msgstr "फ़्लोटिंग IP हटाएँ"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
#: src/modules/metal/status/StatusLabels.tsx
msgid "Deleted"
msgstr "हटाया गया"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "\"{display_name}\" को हटाने पर यह स्थायी रूप से मिट जाएगा, और इसके बाद यह उपलब्ध नहीं रहेगा।"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" would destroy a resource that has already been paid for. Please contact support for assistance."
msgstr "\"{display_name}\" को हटाने से पहले ही भुगतान किया जा चुका संसाधन नष्ट हो जाएगा। सहायता के लिए कृपया सहायता टीम से संपर्क करें।"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Deleting \"{name}\" will permanently remove access from all the users in this group to act as you."
msgstr "\"{name}\" को हटाने से इस समूह के सभी उपयोगकर्ताओं की आपके रूप में कार्य करने की एक्सेस स्थायी रूप से हट जाएगी।"

#. Items: means files or folders
#. placeholder {0}: files.length
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Deleting {count} {0, plural, one {item} other {items}}."
msgstr "{count} {0, plural, one {आइटम} other {आइटम}} हटाए जा रहे हैं।"

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a backup will permanently remove it."
msgstr "बैकअप हटाने पर वह स्थायी रूप से मिट जाएगा।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a billing account \"{title}\" will remove it permanently. Billing account can be deleted only if there are no unpaid resources attached to it and if it has no unspent credit."
msgstr "बिलिंग खाता \"{title}\" हटाने पर यह स्थायी रूप से हट जाएगा। बिलिंग खाता केवल तभी हटाया जा सकता है जब उससे कोई अवैतनिक संसाधन जुड़ा न हो और उसमें कोई अप्रयुक्त क्रेडिट न हो।"

#. placeholder {0}: method.name
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a payment method \"{0}\" will remove it from the billing account."
msgstr "भुगतान विधि \"{0}\" को हटाने पर वह बिलिंग खाते से हट जाएगी।"

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting a service will also delete your backups and the service cannot be restored after that."
msgstr "किसी सेवा को हटाने पर आपके बैकअप भी हट जाएंगे और उसके बाद सेवा को पुनर्स्थापित नहीं किया जा सकेगा।"

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a snapshot will permanently remove it."
msgstr "स्नैपशॉट हटाने पर वह स्थायी रूप से मिट जाएगा।"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the access key \"{accessKey}\" will permanently remove it, and it cannot be used for accessing the storage API after that."
msgstr "एक्सेस कुंजी \"{accessKey}\" को हटाने पर यह स्थायी रूप से हट जाएगी, और इसके बाद इसका उपयोग स्टोरेज API तक पहुँचने के लिए नहीं किया जा सकेगा।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the credit card \"{placeholder}\" will permanently remove it from the billing account."
msgstr "क्रेडिट कार्ड \"{placeholder}\" को हटाने पर वह बिलिंग खाते से स्थायी रूप से हट जाएगा।"

#: src/modules/compute/DiskDeleteModal.tsx
msgid "Deleting the disk will permanently remove it, and it will not be accessible after that."
msgstr "डिस्क को हटाने पर वह स्थायी रूप से मिट जाएगी, और उसके बाद उस तक पहुँच संभव नहीं होगी।"

#. placeholder {0}: name || address
#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Deleting the floating IP address \"{0}\" will remove it from your account and release it to the public pool."
msgstr "फ़्लोटिंग IP पता \"{0}\" हटाने पर यह आपके खाते से हट जाएगा और सार्वजनिक पूल में जारी कर दिया जाएगा।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the invoice method will permanently remove it from the billing account."
msgstr "इनवॉइस विधि को हटाने पर वह बिलिंग खाते से स्थायी रूप से हट जाएगी।"

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting the service \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "सेवा \"{display_name}\" को हटाने पर यह स्थायी रूप से हटा दी जाएगी, और उसके बाद यह एक्सेस नहीं की जा सकेगी।"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the storage account \"{title}\" will permanently remove it and delete all associated keys. Accounts with active buckets cannot be deleted."
msgstr "स्टोरेज खाता \"{title}\" हटाने पर यह स्थायी रूप से हट जाएगा और इससे संबद्ध सभी कुंजियाँ हटा दी जाएँगी। सक्रिय बकेट वाले खाते हटाए नहीं जा सकते।"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Deleting the storage bucket \"{name}\" will permanently remove it, and any files in it will not be accessible after that."
msgstr "स्टोरेज बकेट \"{name}\" को हटाने पर यह स्थायी रूप से हट जाएगा, और इसके भीतर की कोई भी फ़ाइल उसके बाद सुलभ नहीं होगी।"

#: src/modules/access/token/TokenView.tsx
msgid "Deleting the token \"{description}\" will permanently remove it, and it cannot be used for authentication after that."
msgstr "टोकन \"{description}\" को हटाने से यह स्थायी रूप से हट जाएगा, और उसके बाद इसे प्रमाणीकरण के लिए उपयोग नहीं किया जा सकेगा।"

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine \"{name}\" will permanently remove it, and it will not be accessible after that."
msgstr "वर्चुअल मशीन \"{name}\" को हटाने पर यह स्थायी रूप से मिट जाएगी और उसके बाद उस तक पहुँचना संभव नहीं होगा।"

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine will also delete your backups and snapshots, and the machine cannot be restored after that. If you wish to keep the backups and snapshots consider stopping the machine instead."
msgstr "वर्चुअल मशीन को हटाने पर आपके बैकअप और स्नैपशॉट भी हट जाएँगे, और उसके बाद मशीन को पुनर्स्थापित नहीं किया जा सकेगा। यदि आप बैकअप और स्नैपशॉट सुरक्षित रखना चाहते हैं, तो इसके बजाय मशीन को रोकने पर विचार करें।"

#: src/modules/network/vpc/VpcView.tsx
msgid "Deleting the VPC network \"{name}\" will remove it from your account."
msgstr "VPC नेटवर्क \"{name}\" हटाने पर यह आपके खाते से हटा दिया जाएगा।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Description"
msgstr "विवरण"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Destinations"
msgstr "गंतव्य"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/UnattachedItem.tsx
msgid "Detached"
msgstr "अलग किया गया"

#: src/modules/compute/VmView.tsx
msgid "Disable"
msgstr "अक्षम करें"

#: src/modules/compute/VmView.tsx
msgid "Disable backups"
msgstr "बैकअप अक्षम करें"

#: src/modules/user/ProfileView.tsx
msgid "Disable MFA"
msgstr "MFA निष्क्रिय करें"

#: src/components/EnabledDisabled.tsx
msgid "Disabled"
msgstr "निष्क्रिय"

#: src/modules/compute/WVnc.tsx
msgid "Disconnect"
msgstr "डिस्कनेक्ट करें"

#. State of connection: Not connected
#: src/modules/compute/WVnc.tsx
msgid "Disconnected"
msgstr "डिस्कनेक्टेड"

#. Column title for invoice records' discount
#: src/components/PriceWithDiscount.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Discount"
msgstr "छूट"

#: src/modules/api/resourceTypes.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Disk"
msgstr "डिस्क"

#: src/modules/compute/MetricsGrid.tsx
msgid "Disk I/O"
msgstr "डिस्क I/O"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
msgid "Disk size can only be increased. This action is not reversible. Minimum disk size:"
msgstr "डिस्क का आकार केवल बढ़ाया जा सकता है। यह कार्रवाई वापस नहीं की जा सकती। न्यूनतम डिस्क आकार:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Disks"
msgstr "डिस्क"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/CurrencyModal.tsx
msgid "Display currency"
msgstr "प्रदर्शित मुद्रा"

#: src/modules/storage/StorageCreate.tsx
msgid "Display name"
msgstr "प्रदर्शित नाम"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Document"
msgstr "दस्तावेज़"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Document file"
msgstr "दस्तावेज़ फ़ाइल"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Document No."
msgstr "दस्तावेज़ संख्या"

#. Button action to download a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Download"
msgstr "डाउनलोड करें"

#: src/modules/services/Access.tsx
msgid "Download config file"
msgstr "कॉन्फ़िग फ़ाइल डाउनलोड करें"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Download PDF"
msgstr "PDF डाउनलोड करें"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Drop files here"
msgstr "फ़ाइलें यहाँ छोड़ें"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Due date"
msgstr "देय तिथि"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "E-mail"
msgstr "ईमेल"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit"
msgstr "संपादित करें"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Edit \"{title}\""
msgstr "\"{title}\" संपादित करें"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Edit maintenance"
msgstr "मेंटेनेंस संपादित करें"

#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit name"
msgstr "नाम संपादित करें"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Edit node"
msgstr "नोड संपादित करें"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "Edit rule"
msgstr "नियम संपादित करें"

#. Field label
#: src/components/EditableList.tsx
#: src/modules/login/Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Email"
msgstr "ईमेल"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Email domain is prohibited"
msgstr "इस ईमेल डोमेन का उपयोग प्रतिबंधित है"

#: src/modules/login/Login.tsx
msgid "Email verification failed"
msgstr "ईमेल सत्यापन विफल रहा"

#: src/modules/login/Login.tsx
msgid "Email verified"
msgstr "ईमेल सत्यापित हो गया"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Email where invoices and reports are sent."
msgstr "वह ईमेल जिस पर इनवॉइस और रिपोर्ट भेजे जाते हैं।"

#: src/modules/compute/VmCreate.tsx
msgid "Empty disk (for ISO booting)"
msgstr "खाली डिस्क (ISO से बूट करने के लिए)"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Enable"
msgstr "सक्षम करें"

#: src/modules/user/ProfileView.tsx
msgid "Enable MFA"
msgstr "MFA सक्रिय करें"

#: src/modules/access/AccessCreate.tsx
msgid "Enable other users or systems to perform actions with resources connected to this account."
msgstr "अन्य उपयोगकर्ताओं या सिस्टमों को इस खाते से जुड़े संसाधनों पर कार्रवाइयाँ करने की अनुमति दें।"

#: src/components/EnabledDisabled.tsx
msgid "Enabled"
msgstr "सक्रिय"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "End date"
msgstr "समाप्ति तिथि"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "End port"
msgstr "अंतिम पोर्ट"

#: src/modules/network/firewall/validatePorts.ts
msgid "End port must be greater than start port"
msgstr "अंतिम पोर्ट की संख्या प्रारंभिक पोर्ट से अधिक होनी चाहिए"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Ended"
msgstr "समाप्त"

#: src/modules/compute/AddSubInterfaceModal.tsx
msgid "Enter a value between 1 and 4094"
msgstr "1 और 4094 के बीच का मान दर्ज करें"

#. Card security code validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Enter digits only"
msgstr "केवल अंक दर्ज करें"

#. placeholder {0}: currency.title
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Enter the top up amount in {0} (minimum {minimumAmount}):"
msgstr "{0} में टॉप अप राशि दर्ज करें (न्यूनतम {minimumAmount}):"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/error/Isolated.tsx
#: src/modules/login/Login.tsx
#: src/modules/notifications/toast.tsx
msgid "Error"
msgstr "त्रुटि"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Error adding payment method"
msgstr "भुगतान विधि जोड़ने में त्रुटि"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Error code: {code}"
msgstr "त्रुटि कोड: {code}"

#: src/components/button/WButton.tsx
msgid "Error performing action"
msgstr "क्रिया करते समय त्रुटि हुई"

#: src/modules/notifications/toast.tsx
msgid "Error saving changes"
msgstr "बदलाव सहेजने में त्रुटि हुई"

#: src/modules/compute/VmView.tsx
msgid "Est. cost per backup"
msgstr "प्रति बैकअप अनुमानित लागत"

#: src/components/table/DetailsTableMonthlyCost.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Est. monthly cost"
msgstr "अनुमानित मासिक लागत"

#. Short of: Estimated
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Est. total"
msgstr "अनुमानित कुल"

#: src/components/forms/MonthlyCostField.tsx
msgid "Estimated cost"
msgstr "अनुमानित लागत"

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per backup is {priceWithDiscount} per month."
msgstr "प्रति बैकअप अनुमानित मूल्य {priceWithDiscount} प्रति माह है।"

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per snapshot is {priceWithDiscount} per month."
msgstr "प्रति स्नैपशॉट अनुमानित मूल्य {priceWithDiscount} प्रति माह है।"

#. Table column: what happened to the billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Event"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user receives a {c_totalReceiverCredit} worth of free credits when signing up through the referral link or code and adding a verified payment method."
msgstr "हर नए उपयोगकर्ता को रेफ़रल लिंक या कोड के माध्यम से साइन अप करने और एक सत्यापित भुगतान विधि जोड़ने पर {c_totalReceiverCredit} मूल्य के निःशुल्क क्रेडिट मिलते हैं।"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user who signs up through the referral program and tops up at least {c_minimumTopUp} will receive a bonus worth of {c_totalReceiverCredit} credits."
msgstr "हर नया उपयोगकर्ता, जो रेफ़रल प्रोग्राम के माध्यम से साइन अप करता है और कम से कम {c_minimumTopUp} का टॉप अप करता है, उसे {c_totalReceiverCredit} क्रेडिट मूल्य का बोनस मिलेगा।"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Example"
msgstr "उदाहरण"

#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/DisplayCurrencyRate.tsx
msgid "Exchange rate"
msgstr "विनिमय दर"

#. Short of: Excluding (VAT/GST etc.)
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Excl. {vatSymbol}"
msgstr "{vatSymbol} छोड़कर"

#. The number of fail-over nodes:
#: src/modules/services/ServiceCreate.tsx
msgid "Fail-over nodes"
msgstr "फ़ेल-ओवर नोड"

#: src/modules/api/ApiError.ts
msgid "Failed to connect to server"
msgstr "सर्वर से कनेक्ट नहीं हो सका"

#: src/modules/billing/account_validation/digio/utils.ts
msgid "Failed to load Digio library"
msgstr "Digio लाइब्रेरी लोड करने में विफल"

#: src/modules/billing/paypal/utils.ts
msgid "Failed to load PayPal library"
msgstr "PayPal लाइब्रेरी लोड नहीं हो सकी"

#: src/modules/billing/popup/popup.ts
msgid "Failed to open popup, possible popup blocker usage"
msgstr "पॉप-अप खोला नहीं जा सका, संभवतः पॉप-अप ब्लॉकर सक्रिय है"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "File"
msgstr "फ़ाइल"

#: src/modules/storage/bucket/BucketView.tsx
msgid "Files"
msgstr "फ़ाइलें"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Files will be uploaded to"
msgstr "फ़ाइलें यहाँ अपलोड की जाएँगी"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Firewall"
msgstr "फ़ायरवॉल"

#: src/modules/network/NetworkCreate.tsx
msgid "Firewall is available at no additional cost."
msgstr "फ़ायरवॉल बिना किसी अतिरिक्त लागत के उपलब्ध है।"

#: src/modules/compute/VmView.tsx
msgid "Firewall name"
msgstr "फ़ायरवॉल का नाम"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Firewall now available"
msgstr "फ़ायरवॉल अब उपलब्ध है"

#: src/modules/user/ProfileView.tsx
msgid "First name"
msgstr "पहला नाम"

#: src/modules/services/ConnectionDetails.tsx
msgid "Flags"
msgstr "फ़्लैग"

#: src/modules/api/resourceTypes.tsx
msgid "Floating IP"
msgstr "फ़्लोटिंग IP"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder"
msgstr "फ़ोल्डर"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder name"
msgstr "फ़ोल्डर का नाम"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up through the referral program and tops up at least {c_minimumTopUp}, you will receive {c_promoterCredit} worth of free credits."
msgstr "हर नए उपयोगकर्ता के लिए, जो रेफ़रल प्रोग्राम के माध्यम से साइन अप करता है और कम से कम {c_minimumTopUp} का टॉप अप करता है, आपको {c_promoterCredit} मूल्य के निःशुल्क क्रेडिट मिलेंगे।"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up using your referral code and adds a verified payment method, you will receive {c_promoterCredit} worth of free credits."
msgstr "हर नए उपयोगकर्ता के लिए, जो आपके रेफ़रल कोड का उपयोग करके साइन अप करता है और एक सत्यापित भुगतान विधि जोड़ता है, आपको {c_promoterCredit} मूल्य के निःशुल्क क्रेडिट मिलेंगे।"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "For pay-as-you-go billing account you can select the payment method after the account is created and validated."
msgstr "जितना उपयोग करें उतना भुगतान करें वाले बिलिंग खाते के लिए, खाता बनने और सत्यापित होने के बाद आप भुगतान विधि चुन सकते हैं।"

#: src/modules/compute/labels.tsx
msgid "For the snapshots you will only pay for the storage used by the snapshot."
msgstr "स्नैपशॉट के लिए आपको केवल स्नैपशॉट द्वारा उपयोग किए गए स्टोरेज का भुगतान करना होगा।"

#. Unsafely shut down the virtual machine
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Force stop"
msgstr "बलपूर्वक रोकें"

#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
msgid "Forgot password"
msgstr "पासवर्ड भूल गए"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Forwarding rules"
msgstr "फ़ॉरवर्डिंग नियम"

#. At no cost. | POS: Noun
#: src/components/forms/MonthlyCostField.tsx
msgid "Free"
msgstr "निःशुल्क"

#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
msgid "Frequency"
msgstr "आवृत्ति"

#: src/modules/services/ServicesList.tsx
msgid "from"
msgstr "से"

#: src/modules/compute/VmCreate.tsx
msgid "From"
msgstr "से"

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Frozen"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Full path"
msgstr "पूरा पथ"

#: src/modules/services/ServiceView.tsx
msgid "Fully managed database so you can focus on your code."
msgstr "पूरी तरह प्रबंधित डेटाबेस, ताकि आप अपने कोड पर ध्यान केंद्रित कर सकें।"

#: src/modules/api/resourceTypes.tsx
msgid "Fully managed services - we handle the provisioning of underlying infrastructure and the management of the service."
msgstr "पूरी तरह प्रबंधित सेवाएँ - हम आधारभूत इन्फ्रास्ट्रक्चर की प्रोविज़निंग और सेवा के प्रबंधन का काम संभालते हैं।"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Future"
msgstr "भविष्य"

#. Payment gateway that the card is connected to
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Gateway"
msgstr "गेटवे"

#. unit: gigabytes
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/l10n/units.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "GB"
msgstr "GB"

#. Example: 50 GB (of) disk
#: src/modules/l10n/units.tsx
msgid "GB disk"
msgstr "GB डिस्क"

#. Example: 16 GB (of) RAM
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/l10n/units.tsx
msgid "GB RAM"
msgstr "GB RAM"

#. unit: gigabyte-hours (storage usage)
#: src/modules/l10n/units.tsx
msgid "GBh"
msgstr "GBh"

#. Explanation: Generate the subnet range automatically
#: src/modules/network/NetworkCreate.tsx
msgid "Generate (recommended)"
msgstr "स्वचालित रूप से बनाएँ (अनुशंसित)"

#: src/modules/access/AccessCreate.tsx
msgid "Generate an API access token to use our <0>API</0>."
msgstr "हमारी <0>API</0> का उपयोग करने के लिए API एक्सेस टोकन जनरेट करें।"

#: src/modules/access/scopeLabel.tsx
msgid "Global"
msgstr "वैश्विक"

#: src/modules/error/ErrorFallback.tsx
msgid "Go to dashboard"
msgstr "डैशबोर्ड पर जाएँ"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST"
msgstr "GST"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST number"
msgstr "GST नंबर"

#. unit: hours
#: src/modules/l10n/units.tsx
msgid "h"
msgstr "h"

#. Chat widget greeting
#: src/modules/support/WChatProvider.tsx
msgid "Hello"
msgstr "नमस्ते"

#: src/routes/_main_custom/about.lazy.tsx
msgid "Hello world!"
msgstr "नमस्ते दुनिया!"

#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Hibernate"
msgstr "हाइबरनेट करें"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernated"
msgstr "हाइबरनेट किया गया"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernating"
msgstr "हाइबरनेट किया जा रहा है"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Hide"
msgstr "छिपाएँ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Hide details"
msgstr "विवरण छिपाएँ"

#: src/modules/api/resourceTypes.tsx
msgid "High availability load balancer distributes traffic between virtual machines within the same data center location."
msgstr "हाई अवेलेबिलिटी लोड बैलेंसर एक ही डेटा सेंटर लोकेशन के भीतर वर्चुअल मशीनों के बीच ट्रैफ़िक वितरित करता है।"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/period.tsx
msgid "hour"
msgstr "घंटा"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Hourly"
msgstr "प्रति घंटा"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Hourly billing cycle only"
msgstr "केवल प्रति घंटे का बिलिंग चक्र"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Hourly updated usage for current billing period."
msgstr "वर्तमान बिलिंग अवधि के लिए प्रति घंटे अद्यतन उपयोग।"

#: src/modules/dashboard/UserAccess.tsx
msgid "I can access"
msgstr "जिन तक मेरी पहुँच है"

#: src/modules/login/ConsentForm.tsx
msgid "I have read and agree to the <0>Terms of Service</0>"
msgstr "मैंने <0>सेवा की शर्तें</0> पढ़ ली हैं और उनसे सहमत हूँ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "I'm aware that deletion is permanent"
msgstr "मुझे पता है कि हटाना स्थायी है"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "If low balance notifications are active and the balance falls below the threshold, you will be notified."
msgstr "यदि कम शेष राशि की सूचनाएँ सक्रिय हैं और शेष राशि निर्धारित सीमा से नीचे चली जाती है, तो आपको सूचित किया जाएगा।"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "If the active reservation runs out and is not renewed then standard hourly based pricing will be applied."
msgstr "यदि सक्रिय आरक्षण समाप्त हो जाता है और उसका नवीनीकरण नहीं किया जाता है, तो मानक प्रति घंटे की कीमत लागू होगी।"

#: src/modules/billing/choose_method/InvoiceForm.tsx
msgid "If the invoice payment method is not activated instantly, we will contact you with more details. If you do not receive an email from us soon or the invoice payment does not become active, you can contact us at <0/>."
msgstr "यदि चालान भुगतान विधि तुरंत सक्रिय नहीं होती है, तो हम आपसे अधिक जानकारी के साथ संपर्क करेंगे। यदि आपको जल्द ही हमारी ओर से ईमेल प्राप्त नहीं होता है या चालान भुगतान सक्रिय नहीं होता है, तो आप हमसे <0/> पर संपर्क कर सकते हैं।"

#: src/modules/dashboard/Dashboard.tsx
msgid "If you have any questions, found a bug or have a feature request feel free to contact us through <0>support</0>."
msgstr "यदि आपके कोई प्रश्न हैं, आपको कोई बग मिला है, या आपके पास किसी सुविधा का अनुरोध है, तो बेझिझक <0>सहायता</0> के माध्यम से हमसे संपर्क करें।"

#. Description for billing period field
#: src/modules/metal/offer/period.tsx
msgid "In all calculations a precise number of hours is used: 730 for a month, 2190 for a quarter and 8760 for a year."
msgstr "सभी गणनाओं में घंटों की सटीक संख्या का उपयोग किया जाता है: एक महीने के लिए 730, एक तिमाही के लिए 2190 और एक वर्ष के लिए 8760।"

#: src/modules/metal/status/StatusLabels.tsx
msgid "In use"
msgstr "उपयोग में"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Inactive"
msgstr "निष्क्रिय"

#. Short of: inbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "inbound"
msgstr "इनबाउंड"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Inbound rules"
msgstr "इनबाउंड नियम"

#. The price has already been included in the virtual machine's price
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Included in VM price"
msgstr "VM की कीमत में शामिल"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Incoming traffic is allowed only to the specified ports if it originates from the specified sources. All other traffic will be blocked."
msgstr "इनकमिंग ट्रैफ़िक को केवल निर्दिष्ट पोर्ट्स पर ही अनुमति दी जाएगी, यदि वह निर्दिष्ट स्रोतों से आता है। अन्य सभी ट्रैफ़िक अवरुद्ध कर दिए जाएँगे।"

#: src/modules/compute/VmCreate.tsx
msgid "Informative name. It will also be used to generate a suitable hostname for the VM (if applicable)."
msgstr "वर्णनात्मक नाम। इसका उपयोग VM के लिए उपयुक्त होस्टनेम बनाने में भी किया जाएगा (यदि लागू हो)।"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/ServiceView.tsx
msgid "Infrastructure"
msgstr "इन्फ्रास्ट्रक्चर"

#: src/modules/compute/VmCreate.tsx
msgid "Initialization script"
msgstr "प्रारंभिककरण स्क्रिप्ट"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Insert code"
msgstr "कोड दर्ज करें"

#: src/modules/access/AccessCreate.tsx
msgid "Insert email of the {siteName} user you want to delegate access to. The user will need to accept the access invitation from their profile view."
msgstr "जिस {siteName} उपयोगकर्ता को आप एक्सेस डेलीगेट करना चाहते हैं, उसका ईमेल दर्ज करें। उपयोगकर्ता को अपने प्रोफ़ाइल दृश्य से एक्सेस आमंत्रण स्वीकार करना होगा।"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Insufficient funds"
msgstr "अपर्याप्त धनराशि"

#. Field label: identifier used to connect a billing account to an external integration
#. Unique ID number to integrate with external services
#: src/modules/billing/billingAccount/fieldsInfo.tsx
#: src/styles/defaultTheme.tsx
msgid "Integration ID"
msgstr "इंटीग्रेशन आईडी"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid month"
msgstr "अमान्य महीना"

#: src/modules/api/ApiError.ts
msgid "Invalid response from server. Blocked by Stormwall."
msgstr "सर्वर से अमान्य रिस्पॉन्स मिला। Stormwall द्वारा अवरुद्ध।"

#: src/modules/api/ApiError.ts
msgid "Invalid response type from server: Received {ct} instead of JSON."
msgstr "सर्वर से अमान्य रिस्पॉन्स प्रकार मिला: JSON के बजाय {ct} प्राप्त हुआ।"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Invalid signup. The account may already exist."
msgstr "साइन अप अमान्य है। खाता पहले से मौजूद हो सकता है।"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid year"
msgstr "अमान्य वर्ष"

#. What caused the billing account status change
#: src/modules/billing/invoice/DownloadPdf.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Invoice"
msgstr "चालान"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Invoice {id}"
msgstr "चालान {id}"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Invoice details"
msgstr "इनवॉइस विवरण"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Invoice email"
msgstr "इनवॉइस ईमेल"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice has been paid"
msgstr "चालान का भुगतान हो चुका है"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice is not payable"
msgstr "चालान का भुगतान नहीं किया जा सकता"

#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Invoice name"
msgstr "चालान का नाम"

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Invoice payment"
msgstr ""

#: src/components/themeTrans.tsx
msgid "Invoices"
msgstr "इनवॉइस"

#: src/modules/services/IpWhitelist.tsx
msgid "IP"
msgstr "IP"

#: src/modules/services/AddIpForm.tsx
msgid "IP address"
msgstr "IP पता"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "IP address or CIDR range"
msgstr "IP पता या CIDR रेंज"

#. A list of IPs permitted to access the service | Legacy wording: IP whitelist
#: src/modules/services/IpWhitelist.tsx
#: src/modules/services/ServiceView.tsx
msgid "IP allowlist"
msgstr "अनुमत IP सूची"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "IP prefixes"
msgstr "IP प्रीफ़िक्स"

#: src/modules/network/NetworkCreate.tsx
msgid "IP range"
msgstr "IP रेंज"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv4 range"
msgstr "IPv4 रेंज"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv6 range"
msgstr "IPv6 रेंज"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "ISO boot"
msgstr "ISO बूट"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Issue date"
msgstr "जारी करने की तिथि"

#. Date the invoice was issued
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Issued"
msgstr "जारी किया गया"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Keep floating IP"
msgstr "फ़्लोटिंग IP बनाए रखें"

#: src/modules/user/ActAsModal.tsx
msgid "Keep in mind that all the actions will be tracked and can be traced back to you."
msgstr "ध्यान रखें कि सभी कार्रवाइयाँ ट्रैक की जाएँगी और उन्हें आप तक वापस जोड़ा जा सकेगा।"

#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Key name"
msgstr "कुंजी का नाम"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Kubernetes Patch Version"
msgstr "Kubernetes पैच संस्करण"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Kubernetes Patch Version Auto update"
msgstr "Kubernetes पैच संस्करण स्वचालित अपडेट"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Kubernetes service can not be created."
msgstr "Kubernetes सेवा बनाई नहीं जा सकती।"

#: src/modules/l10n/LocaleButton.tsx
msgid "Language"
msgstr "भाषा"

#: src/modules/network/vpc/VpcView.tsx
msgid "Last modified"
msgstr "अंतिम संशोधन"

#: src/modules/user/ProfileView.tsx
msgid "Last name"
msgstr "अंतिम नाम"

#: src/modules/compute/VmView.tsx
msgid "Latest backup"
msgstr "नवीनतम बैकअप"

#. Timestamp of latest snapshot
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/Backups.tsx
msgid "Latest snapshot"
msgstr "नवीनतम स्नैपशॉट"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Less details"
msgstr "कम विवरण"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Light"
msgstr "हल्का"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Limit will be removed once the total top up amount reaches <0/>."
msgstr "कुल टॉप अप राशि <0/> तक पहुँचने पर सीमा हटा दी जाएगी।"

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Limited"
msgstr "सीमित"

#. Column title for invoice records' totals - record amount subtracted by discount
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Line total"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Linked resources"
msgstr "लिंक किए गए संसाधन"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "list price"
msgstr "सूची मूल्य"

#: src/modules/api/resourceTypes.tsx
msgid "Load balancer"
msgstr "लोड बैलेंसर"

#. Button action: load the next rows of the list
#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Load more"
msgstr "और लोड करें"

#: src/modules/billing/progressLabels.tsx
msgid "Loading payment provider"
msgstr "भुगतान प्रदाता लोड किया जा रहा है"

#: src/components/forms/WSelect.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Loading..."
msgstr "लोड हो रहा है..."

#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/location/LocationDetail.tsx
#: src/modules/location/LocationField.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/pricing/PricingModal.tsx
#: src/modules/services/ServicesList.tsx
msgid "Location"
msgstr "स्थान"

#: src/modules/login/ApiKeyLogin.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/LoginLayout.tsx
msgid "Log in"
msgstr "लॉग इन करें"

#: src/modules/login/Login.tsx
msgid "Log in with Google"
msgstr "Google से लॉग इन करें"

#: src/modules/main/LogoutConfirmDialog.tsx
#: src/modules/user/LogoutButton.tsx
#: src/modules/user/UserMenu.tsx
msgid "Log out"
msgstr "लॉग आउट"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Logging in"
msgstr "लॉग इन हो रहा है"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Login error"
msgstr "लॉग इन करने में त्रुटि"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Look around first"
msgstr "पहले एक नज़र डालें"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Low balance notification is not in effect because automated top up is activated."
msgstr "कम शेष राशि की सूचना प्रभावी नहीं है क्योंकि स्वचालित टॉप अप सक्रिय है।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Low balance notifications"
msgstr "कम शेष राशि की सूचनाएँ"

#. MAC address
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "MAC"
msgstr "MAC"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Machine details"
msgstr "मशीन विवरण"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is available for immediate leasing by clients."
msgstr "मशीन ग्राहकों द्वारा तुरंत लीज़ पर लेने के लिए उपलब्ध है।"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is being used by client and is being charged."
msgstr "मशीन का उपयोग ग्राहक द्वारा किया जा रहा है और इसके लिए शुल्क लिया जा रहा है।"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is ordered by client, but does not satisfy the required configuration.<0/>After it has been configured as needed, move to “in use” status."
msgstr "मशीन ग्राहक द्वारा ऑर्डर की गई है, लेकिन यह आवश्यक कॉन्फ़िगरेशन को पूरा नहीं करती है।<0/>आवश्यकतानुसार कॉन्फ़िगर किए जाने के बाद, इसे “उपयोग में” स्थिति में ले जाएँ।"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is unavailable or requires repairs."
msgstr "मशीन अनुपलब्ध है या उसे मरम्मत की आवश्यकता है।"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine requires disk cleaning operations."
msgstr "मशीन में डिस्क सफाई कार्यों की आवश्यकता है।"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Machine type"
msgstr "मशीन प्रकार"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/ServiceView.tsx
msgid "Maintenance"
msgstr "रखरखाव"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/UserMenu.tsx
msgid "Manage"
msgstr "प्रबंधित करें"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Manage API keys"
msgstr "API कुंजियाँ प्रबंधित करें"

#: src/modules/api/resourceTypes.tsx
msgid "Managed service"
msgstr "प्रबंधित सेवा"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Managed services"
msgstr "प्रबंधित सेवाएँ"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Max. surge"
msgstr "अधिकतम सर्ज"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Maximize"
msgstr "बड़ा करें"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Maximum upload file size is {maxFileSizeInMB} MB"
msgstr "अधिकतम अपलोड फ़ाइल आकार {maxFileSizeInMB} MB है"

#. unit: megabytes
#: src/modules/l10n/units.tsx
msgid "MB"
msgstr "MB"

#. unit: megabytes per second
#: src/modules/l10n/units.tsx
msgid "MB/s"
msgstr "MB/s"

#. unit: megabits per second
#: src/modules/l10n/units.tsx
msgid "Mbit/s"
msgstr "Mbit/s"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Method"
msgstr "विधि"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Methods available after validation"
msgstr "सत्यापन के बाद उपलब्ध विधियाँ"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Metrics.tsx
#: src/modules/services/ServiceView.tsx
msgid "Metrics"
msgstr "मेट्रिक्स"

#: src/modules/compute/monitor/MetricChart.tsx
msgid "Metrics for this resource are not loaded for performance reasons"
msgstr "प्रदर्शन कारणों से इस संसाधन के लिए मेट्रिक्स लोड नहीं किए गए हैं"

#: src/modules/user/ProfileView.tsx
msgid "MFA is active for your user."
msgstr "आपके उपयोगकर्ता के लिए MFA सक्रिय है।"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Minimize"
msgstr "छोटा करें"

#. The selected item was not found
#: src/components/forms/WSelect.tsx
msgid "Missing"
msgstr "अनुपलब्ध"

#. If the disk is a boot disk
#: src/modules/compute/VmView.tsx
msgid "Mode"
msgstr "मोड"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
#: src/modules/metal/offer/period.tsx
msgid "month"
msgstr "माह"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Monthly"
msgstr "मासिक"

#: src/components/sidebar/PriceBlock.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/StorageList.tsx
msgid "Monthly cost"
msgstr "मासिक लागत"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "More details"
msgstr "अधिक विवरण"

#: src/modules/user/ProfileView.tsx
msgid "Multi-factor authentication (MFA)"
msgstr "मल्टी-फ़ैक्टर ऑथेंटिकेशन (MFA)"

#: src/modules/billing/forms/BillingSelect.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "N/A"
msgstr "लागू नहीं"

#: src/components/table/DetailsTableName.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Name"
msgstr "नाम"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name (Min {minChars} chars)"
msgstr "नाम (न्यूनतम {minChars} अक्षर)"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name is too short"
msgstr "नाम बहुत छोटा है"

#: src/modules/support/WChatProvider.tsx
msgid "Need help?"
msgstr "मदद चाहिए?"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/network/NetworkList.tsx
msgid "Network"
msgstr "नेटवर्क"

#: src/modules/compute/MetricsGrid.tsx
msgid "Network bandwidth"
msgstr "नेटवर्क बैंडविड्थ"

#: src/modules/compute/VmView.tsx
msgid "Network interfaces"
msgstr "नेटवर्क इंटरफ़ेस"

#: src/modules/compute/VmView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Networking"
msgstr "नेटवर्किंग"

#. Table column: value after the change
#: src/components/sidebar/SidebarList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/NetworkList.tsx
msgid "New"
msgstr "नया"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New file name"
msgstr "नई फ़ाइल का नाम"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder"
msgstr "नया फ़ोल्डर"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder name"
msgstr "नए फ़ोल्डर का नाम"

#: src/modules/network/VpcNetworkSelect.tsx
msgid "New network"
msgstr "नया नेटवर्क"

#: src/modules/compute/PasswordFields.tsx
msgid "New password"
msgstr "नया पासवर्ड"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "New SSH key"
msgstr "नई SSH कुंजी"

#: src/styles/nforce/theme.tsx
msgid "NForce customer ID"
msgstr "NForce ग्राहक ID"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "No active card"
msgstr "कोई सक्रिय कार्ड नहीं है"

#. Chart empty state: no metric samples are available
#: src/modules/compute/monitor/MetricChart.tsx
msgid "No data"
msgstr "कोई डेटा नहीं"

#. Fail-over is disabled, no fail-over nodes
#: src/modules/services/FailoverNodeSelect.tsx
msgid "No Fail-over"
msgstr "कोई फ़ेल-ओवर नहीं"

#. Shown when the billing account status history is empty
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "No history available."
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "No one can access your user account yet"
msgstr "अभी तक कोई भी आपके उपयोगकर्ता खाते तक पहुँच नहीं सकता"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one has shared access with you yet"
msgstr "अभी तक किसी ने भी आपके साथ पहुँच साझा नहीं की है"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "No payment will be made currently. You can change your payment method at any time."
msgstr "अभी कोई भुगतान नहीं किया जाएगा। आप किसी भी समय अपनी भुगतान विधि बदल सकते हैं।"

#: src/components/empty.tsx
msgid "No records"
msgstr "कोई रिकॉर्ड नहीं"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "No reservation billing cycles are available for this server."
msgstr "इस सर्वर के लिए कोई आरक्षण बिलिंग चक्र उपलब्ध नहीं है।"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "No restrictions"
msgstr ""

#: src/components/sidebar/EmptyItem.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/ManagedServices.tsx
msgid "No results found"
msgstr "कोई परिणाम नहीं मिला"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "No verified primary payment method"
msgstr ""

#. Short of: Number of storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "No. of buckets"
msgstr "बकेट की संख्या"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "No. of files"
msgstr "फ़ाइलों की संख्या"

#. Short of: Number of resources
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/NetworkList.tsx
msgid "No. of resources"
msgstr "संसाधनों की संख्या"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "No. of rules"
msgstr "नियमों की संख्या"

#: src/modules/services/Backups.tsx
#: src/modules/services/Metrics.tsx
msgid "Node"
msgstr "नोड"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Node pool"
msgstr "नोड पूल"

#: src/modules/services/ServiceCreate.tsx
msgid "Node pools"
msgstr "नोड पूल"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "nodes"
msgstr "नोड"

#. Items: means files or folders
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If you are deleting substantial number of items, the deletion process may result in an inconsistent state, where some items are deleted while others remain. In the event of such occurrences, please repeat the same action again."
msgstr "नोट: यदि आप बहुत बड़ी संख्या में आइटम हटा रहे हैं, तो हटाने की प्रक्रिया के कारण असंगत स्थिति बन सकती है, जिसमें कुछ आइटम हट जाएँ और कुछ बने रहें। ऐसी स्थिति होने पर कृपया यही कार्रवाई फिर से दोहराएँ।"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If your folder contains a substantial number of files, the renaming process will take time and may result in an inconsistent state where some files are moved to a new location, while others remain in the old folder. In the event of such occurrences, please repeat the action by renaming the same folder once more."
msgstr "नोट: यदि आपके फ़ोल्डर में बहुत बड़ी संख्या में फ़ाइलें हैं, तो नाम बदलने की प्रक्रिया में समय लगेगा और इससे असंगत स्थिति बन सकती है, जिसमें कुछ फ़ाइलें नए स्थान पर चली जाएँ जबकि कुछ पुरानी फ़ोल्डर में ही बनी रहें। ऐसी स्थिति होने पर कृपया उसी फ़ोल्डर का नाम एक बार फिर बदलकर यह कार्रवाई दोहराएँ।"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Note! The owner will know if you have accepted this invitation. They will not be able to access your user account and see or edit any of your resources."
msgstr "ध्यान दें! यदि आप यह आमंत्रण स्वीकार करते हैं, तो स्वामी को इसकी जानकारी होगी। वे आपके उपयोगकर्ता खाते तक पहुँच नहीं कर पाएँगे और न ही आपके किसी संसाधन को देख या संपादित कर पाएँगे।"

#: src/modules/notifications/NotificationMenu.tsx
msgid "Notifications"
msgstr "सूचनाएँ"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Notify when balance goes below"
msgstr "सूचित करें जब शेष राशि इससे नीचे जाए"

#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Notify when balance goes below the following threshold. Keep in mind that the actual limit is defined in base currency."
msgstr "जब शेष राशि नीचे दी गई सीमा से कम हो जाए, तो सूचित करें। ध्यान रखें कि वास्तविक सीमा मूल मुद्रा में निर्धारित होती है।"

#. Availability announcement for AMD EPYC cloud resources
#: src/styles/readyidc/theme.tsx
msgid "Now available"
msgstr "अब उपलब्ध है"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Offline"
msgstr "ऑफ़लाइन"

#. Table column: value before the change
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Old"
msgstr ""

#. Backup frequency
#: src/modules/services/Backups.tsx
msgid "Once a day"
msgstr "दिन में एक बार"

#: src/modules/compute/VmView.tsx
msgid "Once a week (Wednesday at 02:00 UTC)"
msgstr "सप्ताह में एक बार (बुधवार को 02:00 UTC पर)"

#: src/modules/storage/account/SuspendedNotice.tsx
msgid "One of your billing accounts has a problem and your buckets have been suspended. See <0>billing account details</0> for more information or contact support to resolve the issue."
msgstr "आपके बिलिंग खातों में से एक में समस्या है और आपके बकेट निलंबित कर दिए गए हैं। अधिक जानकारी के लिए <0>बिलिंग खाते का विवरण</0> देखें या समस्या के समाधान के लिए सहायता टीम से संपर्क करें।"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
msgid "Ongoing"
msgstr "जारी"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Ongoing balance"
msgstr "वर्तमान शेष राशि"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
msgid "Online"
msgstr "ऑनलाइन"

#. Only payment methods that can be charged automatically
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Only automated methods"
msgstr "केवल स्वचालित विधियाँ"

#: src/modules/compute/VmCreate.tsx
msgid "Only the boot disk will be created! This may cause the OS to not boot properly if the configuration in the OS of source snapshot requires additional disks to be present."
msgstr "केवल बूट डिस्क बनाई जाएगी! यदि स्रोत स्नैपशॉट के OS विन्यास में अतिरिक्त डिस्क की आवश्यकता हो, तो इससे OS सही तरह से बूट नहीं हो सकता।"

#: src/modules/compute/labels.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Operating system"
msgstr "ऑपरेटिंग सिस्टम"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Operating system Auto update"
msgstr "ऑपरेटिंग सिस्टम स्वचालित अपडेट"

#: src/modules/login/Login.tsx
msgid "Or"
msgstr "या"

#: src/styles/dataxion/theme.tsx
msgid "Order"
msgstr "ऑर्डर"

#: src/styles/dataxion/theme.tsx
msgid "Orders"
msgstr "ऑर्डर"

#. Short of: Operating system
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "OS"
msgstr "OS"

#. Short of: outbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "outbound"
msgstr "आउटबाउंड"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Outbound rules"
msgstr "आउटबाउंड नियम"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Outgoing traffic is allowed only to the specified ports of the specified destinations. All other traffic will be blocked."
msgstr "आउटगोइंग ट्रैफ़िक को केवल निर्दिष्ट गंतव्यों के निर्दिष्ट पोर्ट्स पर ही अनुमति दी जाएगी। अन्य सभी ट्रैफ़िक अवरुद्ध कर दिए जाएँगे।"

#: src/modules/billing/BillingList.tsx
msgid "Outstanding amount"
msgstr "बकाया राशि"

#: src/modules/billing/ReportStatus.tsx
msgid "Paid"
msgstr "भुगतान किया गया"

#: src/modules/services/ConnectionDetails.tsx
msgid "Parameters"
msgstr "पैरामीटर"

#: src/modules/compute/PasswordFields.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Password"
msgstr "पासवर्ड"

#: src/modules/compute/PasswordFields.tsx
msgid "Password for the user. Must contain at least one lowercase and one uppercase ASCII letter (a-z, A-Z) and at least one digit (0-9). Minimum length is 8 characters."
msgstr "उपयोगकर्ता के लिए पासवर्ड। इसमें कम से कम एक लोअरकेस और एक अपरकेस ASCII अक्षर (a-z, A-Z) तथा कम से कम एक अंक (0-9) होना चाहिए। न्यूनतम लंबाई 8 वर्ण है।"

#: src/modules/compute/PasswordFields.tsx
msgid "Passwords do not match"
msgstr "पासवर्ड मेल नहीं खाते"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Past"
msgstr "पूर्व"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Path style URL"
msgstr "पाथ शैली URL"

#. Button action: pay for unpaid invoice
#: src/modules/billing/ActionButtons.tsx
msgid "Pay"
msgstr "भुगतान करें"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Pay invoice"
msgstr "चालान का भुगतान करें"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Pay now"
msgstr "अभी भुगतान करें"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Pay the total charge amount of <0>{chargeAmount}</0> with EVC Mobile Money to get {creditAmount} credits. Enter your billing account ID <1>{billingAccountId}</1> as the payment reference."
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Pay-as-you-go (recommended)"
msgstr "जितना उपयोग करें उतना भुगतान करें (अनुशंसित)"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/paymentMethodLogic.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Paying by invoice"
msgstr "चालान द्वारा भुगतान"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (declined / suspended)"
msgstr "चालान द्वारा भुगतान (अस्वीकृत / निलंबित)"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (pending)"
msgstr "चालान द्वारा भुगतान (लंबित)"

#: src/modules/billing/PaymentReturn.tsx
msgid "Payment authorization check finished."
msgstr "भुगतान प्राधिकरण जाँच पूरी हो गई है।"

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled"
msgstr "भुगतान रद्द कर दिया गया"

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled due to high risk"
msgstr "उच्च जोखिम के कारण भुगतान रद्द कर दिया गया"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment details"
msgstr "भुगतान विवरण"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment error"
msgstr "भुगतान त्रुटि"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Payment error: {failure_message}{codeSuffix}"
msgstr "भुगतान त्रुटि: {failure_message}{codeSuffix}"

#: src/modules/billing/clictopay/parseClictopayPaymentResult.ts
#: src/modules/billing/coingate/parseCoingatePaymentResult.ts
#: src/modules/billing/paypal/parsePaypalCheckoutPaymentResult.tsx
#: src/modules/billing/razorpay/parseRazorpayPersistentData.ts
msgid "Payment failed"
msgstr "भुगतान विफल हुआ"

#. What caused the billing account status change
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Payment method"
msgstr "भुगतान विधि"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Payment methods"
msgstr "भुगतान विधियाँ"

#: src/modules/billing/payment_forms/components.tsx
msgid "Payment processing with this method takes some time. Purchased credit will be automatically added to your account once the process is complete."
msgstr "इस विधि से भुगतान संसाधित होने में कुछ समय लगता है। प्रक्रिया पूरी होने पर खरीदा गया क्रेडिट आपके खाते में स्वतः जोड़ दिया जाएगा।"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment type"
msgstr "भुगतान प्रकार"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment was cancelled"
msgstr "भुगतान रद्द कर दिया गया"

#. unit: pieces
#: src/modules/l10n/units.tsx
msgid "pc"
msgstr "pc"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/metal/status/StatusLabels.tsx
#: src/modules/user/ProfileView.tsx
msgid "Pending"
msgstr "लंबित"

#. Billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Pending validation"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Period"
msgstr "अवधि"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Permissions"
msgstr "अनुमतियाँ"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Personal ID number"
msgstr "व्यक्तिगत पहचान संख्या"

#: src/modules/billing/omise/OmisePaymentForm.tsx
#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "Phone number"
msgstr "फ़ोन नंबर"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Platform provided"
msgstr "प्लेटफ़ॉर्म द्वारा प्रदान की गई"

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "Please acknowledge that billing account will not be activated before an administrator has accepted your request."
msgstr "कृपया स्वीकार करें कि आपके अनुरोध को किसी व्यवस्थापक द्वारा स्वीकार किए जाने से पहले बिलिंग खाता सक्रिय नहीं होगा।"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Please allow popup windows to use this payment method"
msgstr "कृपया इस भुगतान विधि का उपयोग करने के लिए पॉप-अप विंडो की अनुमति दें"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Please be patient"
msgstr "कृपया धैर्य रखें"

#: src/modules/billing/progressLabels.tsx
msgid "Please complete the payment in the popup window"
msgstr "कृपया पॉप-अप विंडो में भुगतान पूरा करें"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Please contact support to remove the limit."
msgstr "सीमा हटाने के लिए कृपया सहायता टीम से संपर्क करें।"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please contact the administrators for further details."
msgstr "अधिक जानकारी के लिए कृपया प्रशासकों से संपर्क करें।"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please continue."
msgstr "कृपया जारी रखें।"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Please enter a valid name"
msgstr "कृपया एक मान्य नाम दर्ज करें"

#: src/modules/login/Login.tsx
msgid "Please enter your email address. We will send you an email to reset your password."
msgstr "कृपया अपना ईमेल पता दर्ज करें। हम आपका पासवर्ड रीसेट करने के लिए आपको एक ईमेल भेजेंगे।"

#: src/modules/access/AccessCreate.tsx
msgid "Please finish adding the email"
msgstr "कृपया ईमेल जोड़ना पूरा करें"

#: src/modules/storage/bucket/bucketMessages.tsx
msgid "Please note that the billing account linked to your storage bucket differs from the one associated with your storage account. We highly recommend aligning them for billing consistency and clearer management."
msgstr "कृपया ध्यान दें कि आपके स्टोरेज बकेट से लिंक किया गया बिलिंग खाता, आपके स्टोरेज खाते से संबद्ध बिलिंग खाते से अलग है। बिलिंग में एकरूपता और स्पष्ट प्रबंधन के लिए हम इन्हें एक जैसा रखने की दृढ़ता से अनुशंसा करते हैं।"

#: src/components/forms/MonthlyCostField.tsx
msgid "Please see how the cost of your resource is calculated."
msgstr "कृपया देखें कि आपके संसाधन की लागत कैसे गणना की जाती है।"

#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Please select a VPC network to choose target servers from."
msgstr "कृपया लक्षित सर्वर चुनने के लिए एक VPC नेटवर्क चुनें।"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
msgid "Please select an item in the list"
msgstr "कृपया सूची में से एक आइटम चुनें"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Please upload a copy of the business registration document or ID card for verification (max {maxFileSizeInMB}MB)."
msgstr "कृपया सत्यापन के लिए व्यवसाय पंजीकरण दस्तावेज़ या पहचान पत्र की एक प्रति अपलोड करें (अधिकतम {maxFileSizeInMB}MB)।"

#: src/modules/services/ServiceView.tsx
msgid "Pods and services hosted on this cluster will be stopped and any ephemeral storage will be discarded."
msgstr "इस क्लस्टर पर होस्ट किए गए पॉड और सेवाएँ बंद कर दी जाएँगी और कोई भी अस्थायी स्टोरेज हटा दिया जाएगा।"

#: src/modules/billing/popup/popup.ts
msgid "Popup did not return from redirect"
msgstr "पॉप-अप रीडायरेक्ट से वापस नहीं आया"

#: src/modules/billing/popup/popup.ts
msgid "Popup was closed before it could load"
msgstr "लोड होने से पहले ही पॉप-अप बंद कर दिया गया"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Port"
msgstr "पोर्ट"

#: src/modules/network/validatePort.ts
msgid "Port must be between 1 and 65535"
msgstr "पोर्ट की संख्या 1 और 65535 के बीच होनी चाहिए"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Port range"
msgstr "पोर्ट रेंज"

#: src/modules/services/ServiceCreate.tsx
msgid "PostgreSQL multi-node setup is a Primary/Standby setup with automatic fail-over."
msgstr "PostgreSQL मल्टी-नोड सेटअप स्वचालित फ़ेल-ओवर के साथ एक प्राइमरी/स्टैंडबाय सेटअप है।"

#. Resources attached to the billing account that have already been paid for
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Pre-paid resources"
msgstr "पूर्व-भुगतान किए गए संसाधन"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Pre-payment"
msgstr "अग्रिम भुगतान"

#: src/modules/compute/VmList.tsx
msgid "Price"
msgstr "मूल्य"

#: src/modules/compute/VmCreate.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Price list"
msgstr "मूल्य सूची"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Price per cycle"
msgstr "प्रति चक्र कीमत"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per hour"
msgstr "प्रति घंटा मूल्य"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per month"
msgstr "प्रति माह मूल्य"

#: src/modules/pricing/PricingModal.tsx
msgid "Prices may vary for the options below"
msgstr "नीचे दिए गए विकल्पों के लिए मूल्य अलग हो सकते हैं"

#. The card that is selected for automatic charging (ie. main)
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
msgid "Primary"
msgstr "प्राथमिक"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Private"
msgstr "निजी"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Private images"
msgstr "निजी इमेज"

#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Private IP"
msgstr "निजी IP"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceView.tsx
msgid "Private IPv4"
msgstr "निजी IPv4"

#: src/modules/services/Networking.tsx
msgid "Private network"
msgstr "निजी नेटवर्क"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Problem with PayPal API."
msgstr "PayPal API में समस्या है।"

#: src/modules/user/ProfileView.tsx
#: src/modules/user/UserMenu.tsx
msgid "Profile"
msgstr "प्रोफ़ाइल"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Protocol"
msgstr "प्रोटोकॉल"

#: src/modules/compute/VmCreate.tsx
msgid "Provide a valid cloud-config as JSON or YAML. This configuration will be passed as cloud-init user-data to the virtual machine. See cloud-init documentation about cloud-config for all the available options."
msgstr "JSON या YAML के रूप में मान्य cloud-config प्रदान करें। यह विन्यास cloud-init user-data के रूप में वर्चुअल मशीन को भेजा जाएगा। सभी उपलब्ध विकल्पों के लिए cloud-config संबंधी cloud-init दस्तावेज़ देखें।"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Provider start of maintenance time window in which Provider may schedule automated cluster updates."
msgstr "मेंटेनेंस समय-विंडो का प्रदाता-निर्धारित प्रारंभ, जिसमें प्रदाता स्वचालित क्लस्टर अपडेट शेड्यूल कर सकता है।"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public"
msgstr "सार्वजनिक"

#: src/components/table/DetailsTableIpAddress.tsx
msgid "Public IP addresses are managed in the Network view."
msgstr "सार्वजनिक IP पते नेटवर्क दृश्य में प्रबंधित किए जाते हैं।"

#: src/components/table/DetailsTableIpAddress.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv4"
msgstr "सार्वजनिक IPv4"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv6"
msgstr "सार्वजनिक IPv6"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/user/ProfileView.tsx
msgid "Public key"
msgstr "सार्वजनिक कुंजी"

#: src/modules/compute/labels.tsx
msgid "Public key part of the SSH key pair for logging in to the VM. Must be in format <0>ssh-key-type base64encoded...key optional_comment</0>."
msgstr "VM में लॉग इन करने के लिए SSH कुंजी-युग्म का सार्वजनिक कुंजी भाग। इसका प्रारूप <0>ssh-key-type base64encoded...key optional_comment</0> होना चाहिए।"

#: src/modules/services/ConnectionDetails.tsx
msgid "Public network"
msgstr "सार्वजनिक नेटवर्क"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public URL"
msgstr "सार्वजनिक URL"

#. Short of: Quantity
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Qty."
msgstr "मात्रा"

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "quarter"
msgstr "तिमाही"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Quarterly"
msgstr "त्रैमासिक"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MetricsGrid.tsx
msgid "RAM"
msgstr "RAM"

#: src/modules/compute/VmToolbar.tsx
msgid "RDP link"
msgstr "RDP लिंक"

#: src/modules/services/ServiceView.tsx
msgid "Read more"
msgstr "और पढ़ें"

#. Only read permissions
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Read-only"
msgstr "केवल पढ़ने के लिए"

#: src/modules/services/ServiceView.tsx
msgid "Readiness"
msgstr "तत्परता"

#: src/modules/metal/os/MetalOsSelect.tsx
msgid "Ready"
msgstr "तैयार"

#. Table column: why the restriction level changed
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reason"
msgstr ""

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Reboot"
msgstr "रीबूट करें"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Recent"
msgstr "हाल के"

#: src/modules/billing/progressLabels.tsx
msgid "Redirecting to payment gateway"
msgstr "भुगतान गेटवे पर रीडायरेक्ट किया जा रहा है"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral code"
msgstr "रेफ़रल कोड"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral link"
msgstr "रेफ़रल लिंक"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral program"
msgstr "रेफ़रल प्रोग्राम"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Refresh credit"
msgstr ""

#: src/modules/billing/account_validation/RefreshStatusButton.tsx
msgid "Refresh status"
msgstr "स्थिति ताज़ा करें"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Registration number"
msgstr "पंजीकरण संख्या"

#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstall"
msgstr "पुनः इंस्टॉल करें"

#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstalling \"{name}\" will destroy all data on the boot disk and set it to the initial clean OS state. All snapshots and backups are preserved."
msgstr "\"{name}\" को पुनः इंस्टॉल करने पर बूट डिस्क का सारा डेटा नष्ट हो जाएगा और यह OS की प्रारंभिक स्वच्छ अवस्था में सेट हो जाएगा। सभी स्नैपशॉट और बैकअप सुरक्षित रहेंगे।"

#: src/components/sidebar/ListErrorBoundary.tsx
msgid "Reload"
msgstr "पुनः लोड करें"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Reload data"
msgstr "डेटा फिर से लोड करें"

#: src/root.tsx
msgid "Reload page"
msgstr "पेज फिर से लोड करें"

#: src/modules/billing/PaymentTopItem.tsx
msgid "Remaining credit <0/>"
msgstr "शेष क्रेडिट <0/>"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Remove resource"
msgstr "संसाधन हटाएँ"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Removing the public IPv4 address assignment from this resource will make the resource inaccessible from the public Internet. The IP address will remain reserved to your account. You can manage public IPv4 addresses from the Network menu on the left sidebar."
msgstr "इस संसाधन से सार्वजनिक IPv4 पते का असाइनमेंट हटाने पर यह संसाधन सार्वजनिक इंटरनेट से अभिगम्य नहीं रहेगा। IP पता आपके खाते के लिए आरक्षित रहेगा। आप बाएँ साइडबार में नेटवर्क मेनू से सार्वजनिक IPv4 पतों का प्रबंधन कर सकते हैं।"

#. placeholder {0}: item.grantee_username
#: src/modules/access/delegation/DelegationView.tsx
msgid "Removing user will revoke the rights from \"{0}\" to act as you."
msgstr "उपयोगकर्ता को हटाने से \"{0}\" के आपके रूप में कार्य करने के अधिकार वापस ले लिए जाएँगे।"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Rename"
msgstr "नाम बदलें"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Report"
msgstr "रिपोर्ट"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Report {id}"
msgstr "रिपोर्ट {id}"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reports"
msgstr "रिपोर्टें"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Requested"
msgstr "अनुरोधित"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Reservations"
msgstr "आरक्षण"

#. Disk status
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Reserved"
msgstr "आरक्षित"

#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Reserved and prepaid until <0/> ({daysRemaining} days remaining). Price shown as a monthly equivalent."
msgstr "<0/> तक आरक्षित और पूर्व-भुगतान किया गया ({daysRemaining} दिन शेष)। कीमत मासिक समतुल्य के रूप में दिखाई गई है।"

#: src/modules/user/ProfileView.tsx
msgid "Reset password"
msgstr "पासवर्ड रीसेट करें"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Resize"
msgstr "आकार बदलें"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Resize disk"
msgstr "डिस्क का आकार बदलें"

#: src/modules/compute/VmResizeModal.tsx
msgid "Resizing is only possible when the virtual machine is stopped."
msgstr "आकार बदलना केवल तब संभव है जब वर्चुअल मशीन बंद हो।"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is forbidden. Existing resources are deleted."
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is forbidden. Existing resources are stopped."
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is limited"
msgstr ""

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Resource name"
msgstr "संसाधन का नाम"

#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Resources"
msgstr "संसाधन"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the same VPC network using private addresses of primary interfaces"
msgstr "उसी VPC नेटवर्क के संसाधन, जो प्राथमिक इंटरफ़ेस के निजी पतों का उपयोग करते हैं"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the VPCs shared by VLAN sub-interfaces using their respective private address"
msgstr "VLAN उप-इंटरफ़ेस द्वारा साझा किए गए VPCs के संसाधन, जो अपने-अपने निजी पते का उपयोग करते हैं"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Response seems to be taking longer than expected. Wait a bit and refresh the page to see changes reflected. The result might be either successful or unsuccessful."
msgstr "प्रतिक्रिया आने में अपेक्षा से अधिक समय लग रहा है। कृपया थोड़ी देर प्रतीक्षा करें और परिवर्तन देखने के लिए पेज रीफ़्रेश करें। परिणाम सफल भी हो सकता है और असफल भी।"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Response seems to be taking more time than expected. Wait a bit and refresh the page to see payment status changes reflected. If it doesn't happen in a reasonable time, please contact support."
msgstr "रिस्पॉन्स अपेक्षा से अधिक समय ले रहा है। थोड़ी देर प्रतीक्षा करें और भुगतान स्थिति में हुए बदलाव देखने के लिए पेज रीफ़्रेश करें। यदि उचित समय में ऐसा नहीं होता है, तो कृपया सहायता टीम से संपर्क करें।"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/Backups.tsx
msgid "Restore"
msgstr "पुनर्स्थापित करें"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
msgid "Restore from backup"
msgstr "बैकअप से पुनर्स्थापित करें"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restore from snapshot"
msgstr "स्नैपशॉट से पुनर्स्थापित करें"

#: src/modules/services/Backups.tsx
msgid "Restoring from a backup will overwrite the service's state with the selected backup's state."
msgstr "बैकअप से पुनर्स्थापित करने पर सेवा की वर्तमान स्थिति चयनित बैकअप की स्थिति से अधिलेखित हो जाएगी।"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this backup will overwrite the current state."
msgstr "इस बैकअप को पुनर्स्थापित करने पर वर्तमान स्थिति अधिलेखित हो जाएगी।"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this snapshot will overwrite the current state."
msgstr "इस स्नैपशॉट को पुनर्स्थापित करने पर वर्तमान स्थिति अधिलेखित हो जाएगी।"

#: src/modules/access/scopeLabel.tsx
msgid "Restricted"
msgstr "सीमित"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Restriction level changed"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Retention"
msgstr "रखरखाव अवधि"

#. Button action
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/notifications/toast.tsx
msgid "Retry"
msgstr "फिर से प्रयास करें"

#: src/styles/readyidc/theme.tsx
msgid "Revolutionize your cloud with AMD EPYC"
msgstr "AMD EPYC के साथ अपनी क्लाउड सेवाओं में क्रांतिकारी बदलाव लाएँ"

#. Registre National des Entreprises (RNE) company registration document
#: src/styles/dataxion/theme.tsx
msgid "RNE document"
msgstr "RNE दस्तावेज़"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Rules from all attached firewalls are combined, a connection is allowed if there is at least one rule that allows it."
msgstr "सभी संलग्न फ़ायरवॉल के नियम संयुक्त रूप से लागू होते हैं; यदि कम से कम एक नियम किसी कनेक्शन की अनुमति देता है, तो वह कनेक्शन अनुमत होगा।"

#: src/modules/metal/MetalCreate.tsx
msgid "Run your applications on Bare Metal Servers for full control, security, and raw performance. Provision a dedicated server optimized for your most demanding use cases."
msgstr "पूर्ण नियंत्रण, सुरक्षा और सर्वोत्तम प्रदर्शन के लिए अपने अनुप्रयोग बेयर मेटल सर्वरों पर चलाएँ। अपने सबसे अधिक मांग वाले उपयोग मामलों के लिए अनुकूलित एक समर्पित सर्वर प्रोविजन करें।"

#. Virtual machine status
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/monitor/MetricChart.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Running"
msgstr "चालू"

#: src/modules/storage/StorageCreate.tsx
msgid "S3-compatible object storage allows you to scale your storage resources up and down without any upfront payments. Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr "S3-संगत ऑब्जेक्ट स्टोरेज आपको बिना किसी अग्रिम भुगतान के अपने स्टोरेज संसाधनों को आवश्यकता अनुसार बढ़ाने और घटाने की सुविधा देता है। एक नया स्टोरेज खाता बनाएँ, कुछ बकेट बनाएँ और अपने डेटा को स्केलेबल तरीके से संग्रहीत करना शुरू करें - जितना बढ़े, उतना भुगतान करें।"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Save"
msgstr "सहेजें"

#: src/modules/billing/progressLabels.tsx
msgid "Saving payment information"
msgstr "भुगतान जानकारी सहेजी जा रही है"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "Scan the QR code to pay"
msgstr "भुगतान करने के लिए QR कोड स्कैन करें"

#: src/modules/access/AccessCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "Scope"
msgstr "दायरा"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Search"
msgstr "खोजें"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Secret access key"
msgstr "गुप्त एक्सेस कुंजी"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Select a file"
msgstr "एक फ़ाइल चुनें"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Select a payment method"
msgstr "एक भुगतान विधि चुनें"

#: src/components/forms/WSelect.tsx
msgid "Select an option"
msgstr "एक विकल्प चुनें"

#. placeholder {0}: siteCurrencyInfo.title
#: src/modules/currency/CurrencyModal.tsx
msgid "Select your display currency to view prices in your preferred currency. Displayed amounts and exchange rates are indicative and for informational purposes only. All transactions are processed in the underlying currency ({0}), and final charges may vary based on your payment provider's rates."
msgstr "कीमतों को अपनी पसंदीदा मुद्रा में देखने के लिए प्रदर्शित मुद्रा चुनें। प्रदर्शित राशियाँ और विनिमय दरें केवल संकेतात्मक हैं और केवल जानकारी के उद्देश्य से दी गई हैं। सभी लेन-देन आधारभूत मुद्रा ({0}) में संसाधित किए जाते हैं, और अंतिम शुल्क आपके भुगतान प्रदाता की दरों के आधार पर भिन्न हो सकते हैं।"

#: src/modules/currency/CurrencyModal.tsx
msgid "Select your preferred currency"
msgstr "अपनी पसंदीदा मुद्रा चुनें"

#: src/modules/compute/WVnc.tsx
msgid "Send Ctrl+Alt+Del"
msgstr "Ctrl+Alt+Del भेजें"

#: src/modules/login/Login.tsx
msgid "Send email"
msgstr "ईमेल भेजें"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Server"
msgstr "सर्वर"

#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Server class"
msgstr "सर्वर श्रेणी"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
msgid "Service"
msgstr "सेवा"

#: src/modules/services/ServiceCreate.tsx
msgid "Service name"
msgstr "सेवा का नाम"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/ServicesList.tsx
msgid "Services"
msgstr "सेवाएँ"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Set by an administrator"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Set default"
msgstr "डिफ़ॉल्ट सेट करें"

#. 'private' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'private'"
msgstr "ऑब्जेक्ट का ACL 'private' पर सेट करें"

#. 'public-read' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'public-read'"
msgstr "ऑब्जेक्ट का ACL 'public-read' पर सेट करें"

#. Button action
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "Share access"
msgstr "पहुँच साझा करें"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on Facebook"
msgstr "Facebook पर साझा करें"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on LinkedIn"
msgstr "LinkedIn पर साझा करें"

#. X is the social network
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on X"
msgstr "X पर साझा करें"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Share temporarily"
msgstr "अस्थायी रूप से साझा करें"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sharing duration"
msgstr "साझा करने की अवधि"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Show"
msgstr "दिखाएँ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Show details"
msgstr "विवरण दिखाएँ"

#. An item is any kind of resource being managed (e.g. VM, disk, bucket, etc).
#: src/modules/dashboard/RecentlyModified.tsx
msgid "Showing {limit} latest items"
msgstr "नवीनतम {limit} आइटम दिखाए जा रहे हैं"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Showing list prices. Discount applied in the cost summary."
msgstr "सूची मूल्य दिखाए जा रहे हैं। लागत सारांश में छूट लागू की गई है।"

#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Sign up"
msgstr "साइन अप करें"

#: src/modules/login/Login.tsx
msgid "Sign up with Google"
msgstr "Google से साइन अप करें"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
msgid "Size"
msgstr "आकार"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Size (GB)"
msgstr "आकार (GB)"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Snapshots"
msgstr "स्नैपशॉट"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Social share"
msgstr "सोशल शेयर"

#: src/modules/metal/spec/SpecRadio.tsx
msgid "Sold out"
msgstr "स्टॉक समाप्त"

#. Label for dropdown menu that selects by what files are sorted. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort"
msgstr "क्रमबद्ध करें"

#: src/components/sidebar/SortMenu.tsx
msgid "Sort by"
msgstr "इसके अनुसार क्रमबद्ध करें"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by date"
msgstr "तिथि के अनुसार क्रमबद्ध करें"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by name"
msgstr "नाम के अनुसार क्रमबद्ध करें"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by size"
msgstr "आकार के अनुसार क्रमबद्ध करें"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
msgid "Source port"
msgstr "स्रोत पोर्ट"

#: src/modules/network/loadbalancer/validatePorts.ts
msgid "Source port must be unique"
msgstr "स्रोत पोर्ट अलग होना चाहिए"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Sources"
msgstr "स्रोत"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "SSH key does not match required pattern"
msgstr "SSH कुंजी आवश्यक प्रारूप से मेल नहीं खाती"

#: src/modules/compute/VmCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "SSH keys"
msgstr "SSH कुंजियाँ"

#: src/modules/compute/VmCreate.tsx
msgid "SSH keys can be managed under your <0>user profile</0>."
msgstr "SSH कुंजियों का प्रबंधन आपके <0>उपयोगकर्ता प्रोफ़ाइल</0> में किया जा सकता है।"

#: src/modules/compute/VmToolbar.tsx
msgid "SSH link"
msgstr "SSH लिंक"

#: src/modules/compute/VmRootUserWarning.tsx
msgid "SSH might not be available for root user due to operating system initial setup. Please use virtual console to access the system and make the SSH server config changes according to your needs."
msgstr "ऑपरेटिंग सिस्टम के प्रारंभिक सेटअप के कारण root उपयोगकर्ता के लिए SSH उपलब्ध न भी हो सकता है। कृपया सिस्टम तक पहुँचने के लिए वर्चुअल कंसोल का उपयोग करें और अपनी आवश्यकता के अनुसार SSH सर्वर कॉन्फ़िगरेशन में परिवर्तन करें।"

#. Button action
#: src/modules/compute/BootFromIsoModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/support/WChatProvider.tsx
#: src/modules/user/ActAsModal.tsx
msgid "Start"
msgstr "चालू करें"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Start date"
msgstr "प्रारंभ तिथि"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
msgid "Start here"
msgstr "यहाँ से शुरू करें"

#: src/modules/network/NetworkCreate.tsx
msgid "Start managing your networks by creating a new network resource."
msgstr "नया नेटवर्क संसाधन बनाकर अपने नेटवर्क का प्रबंधन शुरू करें।"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Start port"
msgstr "प्रारंभिक पोर्ट"

#: src/modules/network/firewall/validatePorts.ts
msgid "Start port must be unique"
msgstr "प्रारंभिक पोर्ट अलग होना चाहिए"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Start something new"
msgstr "कुछ नया शुरू करें"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Start time"
msgstr "प्रारंभ समय"

#: src/modules/billing/progressLabels.tsx
msgid "Starting payment"
msgstr "भुगतान शुरू किया जा रहा है"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "State"
msgstr "राज्य"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Status"
msgstr "स्थिति"

#. Short of: billing account status history
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Status history"
msgstr ""

#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Stop"
msgstr "बंद करें"

#. Virtual machine status
#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Stopped"
msgstr "बंद"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
msgid "Stopping"
msgstr "रोका जा रहा है"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/storage/StorageList.tsx
msgid "Storage"
msgstr "स्टोरेज"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage access keys"
msgstr "स्टोरेज एक्सेस कुंजियाँ"

#: src/modules/api/resourceTypes.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Storage account"
msgstr "स्टोरेज खाता"

#: src/modules/api/resourceTypes.tsx
msgid "Storage bucket"
msgstr "स्टोरेज बकेट"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Storage bucket name"
msgstr "स्टोरेज बकेट का नाम"

#. List of S3 storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage buckets"
msgstr "स्टोरेज बकेट"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Street address"
msgstr "सड़क का पता"

#: src/modules/services/ConnectionDetails.tsx
msgid "String"
msgstr "स्ट्रिंग"

#: src/modules/network/NetworkCreate.tsx
msgid "Subnet range (CIDR)"
msgstr "सबनेट रेंज (CIDR)"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal"
msgstr "उप-योग"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal before discounts"
msgstr ""

#. Button label. Short of: Contact customer support
#: src/modules/main/TopNav.tsx
msgid "Support"
msgstr "सहायता"

#. Billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Suspended"
msgstr "निलंबित"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Suspension reason changed"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to Grid view"
msgstr "ग्रिड दृश्य पर जाएँ"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to List view"
msgstr "सूची दृश्य पर जाएँ"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "system"
msgstr "सिस्टम"

#. What caused the billing account status change
#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "System"
msgstr ""

#: src/modules/compute/labels.tsx
msgid "Take a snapshot to create an instant image of your virtual machine's current state. You can later use the snapshot to restore your virtual machine state or create a new virtual machine from the snapshot with modified size parameters."
msgstr "अपनी वर्चुअल मशीन की वर्तमान स्थिति की तात्कालिक इमेज बनाने के लिए स्नैपशॉट लें। बाद में आप स्नैपशॉट का उपयोग करके अपनी वर्चुअल मशीन की स्थिति पुनर्स्थापित कर सकते हैं या बदले हुए आकार पैरामीटरों के साथ स्नैपशॉट से नई वर्चुअल मशीन बना सकते हैं।"

#: src/modules/compute/VmView.tsx
msgid "Take snapshot"
msgstr "स्नैपशॉट लें"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Take some action and you'll never see this cactus again."
msgstr "कोई कार्रवाई करें और आपको यह कैक्टस फिर कभी नहीं दिखेगा।"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Target port"
msgstr "लक्षित पोर्ट"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Target servers"
msgstr "लक्ष्य सर्वर"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/WVnc.tsx
msgid "Terminal"
msgstr "कंसोल"

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Terminated"
msgstr ""

#: src/modules/login/ConsentForm.tsx
msgid "Terms of Service"
msgstr "सेवा की शर्तें"

#: src/modules/pricing/PricingModal.tsx
msgid "The actual cost of your resource is calculated based on the below prices and your actual hourly usage. All prices are per one unit of resource (1 vCPU or 1 GiB). Prices do not contain taxes."
msgstr "आपके संसाधन की वास्तविक लागत नीचे दिए गए मूल्यों और आपके वास्तविक प्रति घंटा उपयोग के आधार पर गणना की जाती है। सभी मूल्य संसाधन की एक इकाई (1 vCPU या 1 GiB) के लिए हैं। मूल्यों में कर शामिल नहीं हैं।"

#: src/modules/billing/forms/BillingSelect.tsx
msgid "The billing account has been closed and is no longer available."
msgstr "बिलिंग खाता बंद कर दिया गया है और अब उपलब्ध नहीं है।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "The campaign code is activated only after a successful top up."
msgstr "अभियान कोड केवल सफल टॉप अप के बाद ही सक्रिय होता है।"

#: src/modules/user/ActAsModal.tsx
msgid "The entire user interface will switch and act as you were that user. Once you are finished you can stop the session by clicking “Back to your account” button on the header bar and the user interface will switch back to your account."
msgstr "पूरा यूज़र इंटरफ़ेस बदल जाएगा और ऐसे काम करेगा जैसे आप वही उपयोगकर्ता हों। काम पूरा होने पर, आप हेडर बार में “Back to your account” बटन पर क्लिक करके सत्र रोक सकते हैं, और यूज़र इंटरफ़ेस फिर से आपके खाते पर वापस आ जाएगा।"

#: src/modules/billing/ConversionMessage.tsx
msgid "The final exchange rate and charge amount will be determined at the moment of actual payment."
msgstr "अंतिम विनिमय दर और शुल्क राशि वास्तविक भुगतान के समय निर्धारित की जाएगी।"

#: src/modules/billing/promotionNotices.tsx
msgid "The first top up will unlock your complimentary free credit of <0><1/></0>."
msgstr "पहला टॉप अप करने पर <0><1/></0> का आपका निःशुल्क क्रेडिट अनलॉक हो जाएगा।"

#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "The format is MM/YY"
msgstr "प्रारूप MM/YY है"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "The link expires on:"
msgstr "लिंक की समय-सीमा समाप्त होने की तिथि:"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "The name can only contain lowercase alphanumeric characters and dashes, it must start with a lowercase letter or number, the allowed length is 3–63."
msgstr "नाम में केवल छोटे अक्षरों के अक्षरांकीय वर्ण और डैश हो सकते हैं, यह छोटे अक्षर या अंक से शुरू होना चाहिए, और इसकी अनुमत लंबाई 3–63 है।"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The password can be changed for any existing user account."
msgstr "पासवर्ड किसी भी मौजूदा उपयोगकर्ता खाते के लिए बदला जा सकता है।"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "The phone/mobile number to contact if any issue arises"
msgstr "किसी समस्या की स्थिति में संपर्क के लिए फोन/मोबाइल नंबर"

#: src/components/forms/MonthlyCostField.tsx
msgid "The price is approximate, the cost of your resource will be calculated based on your actual hourly usage."
msgstr "यह मूल्य अनुमानित है, आपके संसाधन की लागत आपके वास्तविक प्रति घंटा उपयोग के आधार पर गणना की जाएगी।"

#: src/modules/compute/PasswordFields.tsx
msgid "The re-typed password, to ensure that it has been entered correctly."
msgstr "दोबारा दर्ज किया गया पासवर्ड, ताकि यह सुनिश्चित किया जा सके कि इसे सही तरीके से दर्ज किया गया है।"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account does not have enough credit to purchase this reservation."
msgstr "चयनित बिलिंग खाते में इस आरक्षण को खरीदने के लिए पर्याप्त क्रेडिट नहीं है।"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account is limited and can not create reservations."
msgstr "चयनित बिलिंग खाता सीमित है और आरक्षण नहीं बना सकता।"

#: src/modules/network/NetworkCreate.tsx
msgid "The subnet must fall within one the following IP blocks:"
msgstr "सबनेट निम्नलिखित IP ब्लॉकों में से किसी एक के भीतर होना चाहिए:"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The user account for which password will be set."
msgstr "वह उपयोगकर्ता खाता जिसके लिए पासवर्ड सेट किया जाएगा।"

#: src/modules/login/Login.tsx
msgid "There was an error verifying your email address."
msgstr "आपके ईमेल पते का सत्यापन करते समय एक त्रुटि हुई।"

#: src/components/sidebar/ErrorItem.tsx
msgid "There was an error while creating your resource."
msgstr "आपका संसाधन बनाते समय त्रुटि हुई।"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "These credentials are only for the initial login. It is recommended to change these immediately."
msgstr "ये विवरण केवल प्रारंभिक लॉगिन के लिए हैं। इन्हें तुरंत बदलने की सलाह दी जाती है।"

#. This resource was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This {resourceTypeName} is gone"
msgstr "यह {resourceTypeName} अब मौजूद नहीं है"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "This bare metal server is still being set up."
msgstr "यह बेयर मेटल सर्वर अभी सेट अप किया जा रहा है।"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "This billing account has limited capabilities when creating resources."
msgstr "संसाधन बनाते समय इस बिलिंग खाते की क्षमताएँ सीमित हैं।"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "This billing account is limited"
msgstr "यह बिलिंग खाता सीमित है"

#: src/modules/compute/VmCreate.tsx
msgid "This distribution adds a <0/> cost per hour for licensing (<1/> per month)."
msgstr "यह वितरण लाइसेंसिंग के लिए प्रति घंटा <0/> अतिरिक्त लागत जोड़ता है (प्रति माह <1/>)।"

#: src/components/forms/requiredMessage.tsx
msgid "This field is required"
msgstr "यह फ़ील्ड आवश्यक है"

#: src/modules/storage/account/CreateKeyModal.tsx
msgid "This key has access to all buckets under this storage account. To restrict access to specific buckets, create a separate storage account."
msgstr "इस कुंजी के पास इस स्टोरेज खाते के अंतर्गत सभी बकेट का एक्सेस है। विशिष्ट बकेट तक एक्सेस सीमित करने के लिए अलग स्टोरेज खाता बनाएँ।"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This page is gone"
msgstr "यह पृष्ठ अब मौजूद नहीं है"

#: src/modules/services/Access.tsx
#: src/modules/services/Networking.tsx
msgid "This service is accessible only by resources in the same VPC network using these private addresses."
msgstr "यह सेवा केवल उसी VPC नेटवर्क के संसाधनों द्वारा इन निजी पतों का उपयोग करके ही एक्सेस की जा सकती है।"

#: src/modules/compute/VmView.tsx
msgid "This virtual machine is accessible by:"
msgstr "यह वर्चुअल मशीन इनसे सुलभ है:"

#: src/modules/network/firewall/FirewallDeleteModal.tsx
msgid "This will delete the firewall and its associated rules, and they will no longer apply to any assigned resources."
msgstr "इससे फ़ायरवॉल और उससे जुड़े नियम हटा दिए जाएँगे, और वे अब किसी भी असाइन किए गए संसाधन पर लागू नहीं होंगे।"

#: src/modules/compute/VmToolbar.tsx
msgid "This will forcefully shut down your resource \"{name}\". For stopped resources you will only be charged for the storage."
msgstr "यह आपके संसाधन \"{name}\" को बलपूर्वक बंद कर देगा। बंद संसाधनों के लिए आपसे केवल स्टोरेज का शुल्क लिया जाएगा।"

#: src/modules/services/ServiceView.tsx
msgid "This will hibernate cluster \"{display_name}\"."
msgstr "इससे क्लस्टर \"{display_name}\" हाइबरनेट हो जाएगा।"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "This will only be used within the system so it's easy for you to recognize the account if you have several."
msgstr "यह केवल सिस्टम के भीतर उपयोग किया जाएगा, ताकि यदि आपके पास कई खाते हों तो आप इस खाते को आसानी से पहचान सकें।"

#: src/modules/compute/VmToolbar.tsx
msgid "This will reboot your resource \"{name}\"."
msgstr "यह आपके संसाधन \"{name}\" को रीबूट करेगा।"

#: src/modules/services/IpWhitelist.tsx
msgid "This will remove the address or range from the allowlist.<0/>Note that an empty allowlist will permit connections from any address."
msgstr "यह पते या रेंज को अनुमत IP सूची से हटा देगा।<0/>ध्यान दें कि खाली अनुमत IP सूची किसी भी पते से कनेक्शन की अनुमति देगी।"

#: src/modules/services/ServiceView.tsx
msgid "This will shut down your resource \"{display_name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "इससे आपका संसाधन \"{display_name}\" बंद हो जाएगा। यदि सुचारु शटडाउन 120 सेकंड में पूरा नहीं होता है, तो बलपूर्वक बंद किया जाएगा। बंद संसाधनों के लिए आपसे केवल स्टोरेज का शुल्क लिया जाएगा।"

#: src/modules/compute/VmToolbar.tsx
msgid "This will shut down your resource \"{name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "यह आपके संसाधन \"{name}\" को बंद कर देगा। यदि सामान्य शटडाउन 120 सेकंड में पूरा नहीं होता है, तो इसे बलपूर्वक रोका जाएगा। बंद संसाधनों के लिए आपसे केवल स्टोरेज का शुल्क लिया जाएगा।"

#: src/modules/network/loadbalancer/LoadBalancerDeleteModal.tsx
msgid "This will stop forwarding traffic to the targets and remove the load balancer."
msgstr "इससे लक्ष्यों तक ट्रैफ़िक फ़ॉरवर्ड होना बंद हो जाएगा और लोड बैलेंसर हटा दिया जाएगा।"

#. Amount below which a low balance notification will be sent
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Threshold"
msgstr "सीमा"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. Here are some ideas where to go next:"
msgstr "अब आगे बढ़ने का समय है। आगे कहाँ जाएँ, इसके लिए कुछ सुझाव यहाँ हैं:"

#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. This item is deleted or you do not have access."
msgstr "अब आगे बढ़ने का समय है। यह आइटम हटाया जा चुका है या आपके पास इसकी पहुँच नहीं है।"

#: src/modules/billing/razorpay/RazorpayPaymentForm.tsx
msgid "Timed out waiting for a response from Razorpay"
msgstr "Razorpay के जवाब की प्रतीक्षा का समय समाप्त हो गया"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Timezone"
msgstr "समय क्षेत्र"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "To activate a billing account, please add a credit card as a payment method or contact support to enable invoice payments."
msgstr "बिलिंग खाते को सक्रिय करने के लिए, कृपया भुगतान विधि के रूप में क्रेडिट कार्ड जोड़ें या चालान भुगतान सक्षम कराने के लिए सहायता से संपर्क करें।"

#: src/modules/services/IpWhitelist.tsx
msgid "To restrict connections to the service you have to add at least one inbound IP to the allowlist (All other public and private connections will be denied). You can specify a single IPv4 address or a block of addresses using CIDR notation (e.g. 1.1.1.0/24)"
msgstr "सेवा से कनेक्शन सीमित करने के लिए आपको अनुमत IP सूची में कम से कम एक इनबाउंड IP जोड़ना होगा (अन्य सभी सार्वजनिक और निजी कनेक्शन अस्वीकार कर दिए जाएंगे)। आप एकल IPv4 पता या CIDR नोटेशन का उपयोग करके पतों का एक ब्लॉक निर्दिष्ट कर सकते हैं (जैसे 1.1.1.0/24)।"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/WelcomeModal.tsx
msgid "To start using the platform you need to first setup billing account. You are welcome to click around to familiarize yourself with the system and come back to billing account creation at any time you are ready to start building your first resources."
msgstr "प्लेटफ़ॉर्म का उपयोग शुरू करने के लिए आपको पहले बिलिंग खाता सेट अप करना होगा। आप सिस्टम से परिचित होने के लिए विभिन्न विकल्पों को देख सकते हैं और जब भी आप अपने पहले संसाधन बनाना शुरू करने के लिए तैयार हों, तब बिलिंग खाता बनाने पर वापस आ सकते हैं।"

#: src/modules/login/ConsentForm.tsx
msgid "To use our services, you need to agree to the Terms of Service."
msgstr "हमारी सेवाओं का उपयोग करने के लिए, आपको सेवा की शर्तों से सहमत होना होगा।"

#: src/modules/access/token/TokenView.tsx
msgid "Token"
msgstr "टोकन"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up"
msgstr "टॉप अप करें"

#. How much to top up | POS: Noun
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Top up amount"
msgstr "टॉप अप राशि"

#: src/modules/billing/promotionNotices.tsx
msgid "Top up at least <0><1/></0> to obtain <2><3/></2> of referral code bonus."
msgstr "रेफ़रल कोड बोनस के रूप में <2><3/></2> प्राप्त करने के लिए कम से कम <0><1/></0> का टॉप अप करें।"

#: src/modules/billing/ActionButtons.tsx
msgid "Top up now"
msgstr "अभी टॉप अप करें"

#. Top up your billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up your account"
msgstr "अपने खाते में टॉप अप करें"

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Top-up"
msgstr ""

#. Invoices for billing account top-ups
#: src/components/themeTrans.tsx
msgid "Top-up invoices"
msgstr "टॉप अप इनवॉइस"

#: src/styles/dataxion/theme.tsx
msgid "Top-up orders"
msgstr "टॉप अप ऑर्डर"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-up threshold reached"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-ups of <0/> are below the threshold of <1/>"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-ups of <0/> reached the threshold of <1/>"
msgstr ""

#. Total amount of the invoice
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Total"
msgstr "कुल"

#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Total charge"
msgstr "कुल शुल्क"

#. Short of: Total excluding
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Total excl. {vatSymbol}"
msgstr "कुल ({vatSymbol} छोड़कर)"

#: src/components/themeTrans.tsx
msgid "Total of all unpaid invoices. Including {vatSymbol}."
msgstr "सभी अवैतनिक इनवॉइस का कुल योग। {vatSymbol} सहित।"

#: src/styles/dataxion/theme.tsx
msgid "Total of all unpaid orders. Including VAT."
msgstr "सभी अवैतनिक ऑर्डरों का कुल योग। VAT सहित।"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Transaction fee"
msgstr "लेनदेन शुल्क"

#. Table column: what caused the change | POS: Noun
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Trigger"
msgstr ""

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "Type"
msgstr "प्रकार"

#: src/modules/compute/labels.tsx
msgid "UEFI variables (NVRAM) will not persist across reboots."
msgstr "UEFI वेरिएबल (NVRAM) रीबूट के बाद सुरक्षित नहीं रहेंगे।"

#: src/modules/access/AccessList.tsx
msgid "UI"
msgstr "UI"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/UnAssignButton.tsx
msgid "Unassign"
msgstr "असाइनमेंट हटाएँ"

#. State of IP address
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/UnassignedItem.tsx
msgid "Unassigned"
msgstr "अनावंटित"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Unit"
msgstr "इकाई"

#. Label for an unknown item in a select control
#: src/components/EnumBadge.tsx
#: src/modules/billing/BillingAccountLink.tsx
#: src/modules/network/NetworkList.tsx
msgid "Unknown"
msgstr "अज्ञात"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Unknown Auth0 error"
msgstr "अज्ञात Auth0 त्रुटि"

#: src/modules/access/scopeLabel.tsx
msgid "Unknown billing account"
msgstr "अज्ञात बिलिंग खाता"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Unknown payment error{codeSuffix}"
msgstr "अज्ञात भुगतान त्रुटि{codeSuffix}"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/network/AssignToSelect.tsx
msgid "Unknown resource"
msgstr "अज्ञात संसाधन"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Unlink target"
msgstr "लक्ष्य का लिंक हटाएँ"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Unpaid"
msgstr "अवैतनिक"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Unpaid amount"
msgstr "अवैतनिक राशि"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Unverified"
msgstr "असत्यापित"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update"
msgstr "अपडेट करें"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update SSH key"
msgstr "SSH कुंजी अपडेट करें"

#. Button action to upload a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Upload"
msgstr "अपलोड करें"

#: src/styles/dataxion/theme.tsx
msgid "Upload a copy of only the RNE document for verification"
msgstr "सत्यापन के लिए केवल RNE दस्तावेज़ की एक प्रति अपलोड करें"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploading files"
msgstr "फ़ाइलें अपलोड की जा रही हैं"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploads are still in progress. If you leave this page, progress will no longer be shown and uploads may be interrupted. Leave anyway?"
msgstr "अपलोड अभी भी प्रगति पर हैं। यदि आप यह पृष्ठ छोड़ते हैं, तो प्रगति नहीं दिखाई जाएगी और अपलोड बाधित हो सकते हैं। फिर भी छोड़ें?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Usage"
msgstr "उपयोग"

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Usage charge"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Use the ISO boot option after the virtual machine has been created to install an operating system yourself."
msgstr "वर्चुअल मशीन बन जाने के बाद ऑपरेटिंग सिस्टम स्वयं इंस्टॉल करने के लिए ISO बूट विकल्प का उपयोग करें।"

#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "User"
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "User access"
msgstr "उपयोगकर्ता पहुँच"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "User must accept access invitation from their profile view"
msgstr "उपयोगकर्ता को अपने प्रोफ़ाइल दृश्य से एक्सेस आमंत्रण स्वीकार करना होगा"

#. Link to regular user interface
#: src/modules/user/UserMenu.tsx
msgid "User view"
msgstr "उपयोगकर्ता दृश्य"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "User's email"
msgstr "उपयोगकर्ता का ईमेल"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Username"
msgstr "उपयोगकर्ता नाम"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users I can access"
msgstr "वे उपयोगकर्ता जिन तक मेरी पहुँच है"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users who can access my account"
msgstr "वे उपयोगकर्ता जो मेरे खाते तक पहुँच सकते हैं"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "UUID"
msgstr "UUID"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Valid thru"
msgstr "वैधता तिथि"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Validation pending"
msgstr "सत्यापन लंबित है"

#: src/modules/compute/ParamsTextField.tsx
msgid "Value does not match required pattern"
msgstr "मान आवश्यक प्रारूप से मेल नहीं खाता"

#: src/components/VatText.tsx
msgid "VAT"
msgstr "VAT"

#: src/components/VatText.tsx
msgid "VAT number"
msgstr "VAT नंबर"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MachineSizeInfo.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "vCPU"
msgstr "vCPU"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Verified"
msgstr "सत्यापित"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Verified payment method is missing"
msgstr "सत्यापित भुगतान विधि उपलब्ध नहीं है"

#: src/modules/billing/progressLabels.tsx
msgid "Verifying payment method"
msgstr "भुगतान विधि सत्यापित की जा रही है"

#: src/modules/compute/os/OsVersionSelect.tsx
#: src/modules/metal/os/MetalOsSelect.tsx
#: src/modules/services/os/OsVersionSelect.tsx
msgid "Version"
msgstr "संस्करण"

#. Button action
#: src/components/ResourceLink.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/notifications/toast.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "View"
msgstr "देखें"

#: src/components/table/WTable.tsx
msgid "View all records"
msgstr "सभी रिकॉर्ड देखें"

#: src/modules/compute/VmView.tsx
msgid "View config commands"
msgstr "कॉन्फ़िगरेशन कमांड देखें"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "View details"
msgstr "विवरण देखें"

#: src/components/table/WTable.tsx
msgid "View last {limit} records"
msgstr "अंतिम {limit} रिकॉर्ड देखें"

#: src/modules/user/InvitationNotice.tsx
msgid "View more"
msgstr "और देखें"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Virtual host style URL"
msgstr "वर्चुअल होस्ट शैली URL"

#: src/modules/api/resourceTypes.tsx
msgid "Virtual machine"
msgstr "वर्चुअल मशीन"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "VLAN"
msgstr "VLAN"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
msgid "VLAN ID"
msgstr "VLAN ID"

#: src/modules/services/Networking.tsx
msgid "VPC IP range"
msgstr "VPC IP रेंज"

#: src/modules/compute/VmView.tsx
msgid "VPC name"
msgstr "VPC नाम"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/VpcRow.tsx
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "VPC network"
msgstr "VPC नेटवर्क"

#: src/modules/network/NetworkCreate.tsx
msgid "VPC network is available at no additional cost."
msgstr "VPC नेटवर्क बिना किसी अतिरिक्त लागत के उपलब्ध है।"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Wait for verification or add card"
msgstr "सत्यापन की प्रतीक्षा करें या कार्ड जोड़ें"

#: src/modules/billing/progressLabels.tsx
msgid "Waiting for payment confirmation"
msgstr "भुगतान पुष्टि की प्रतीक्षा की जा रही है"

#: src/modules/billing/popup/popup.ts
msgid "Waiting for popup to return from redirect timed out"
msgstr "रीडायरेक्ट से पॉप-अप के वापस आने की प्रतीक्षा का समय समाप्त हो गया"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Waking up"
msgstr "सक्रिय किया जा रहा है"

#: src/modules/access/AdminUserWarning.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Warning"
msgstr "चेतावनी"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Warning: It is recommended to stop the virtual machine before resizing the boot disk."
msgstr "चेतावनी: बूट डिस्क का आकार बदलने से पहले वर्चुअल मशीन को बंद करने की सलाह दी जाती है।"

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "We recommend adding a credit card while your request is being processed to activate services right away."
msgstr "हम अनुशंसा करते हैं कि आपकी अनुरोध प्रक्रिया के दौरान आप एक क्रेडिट कार्ड जोड़ें, ताकि सेवाएँ तुरंत सक्रिय हो सकें।"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "We recommend automated top up as it minimizes the risk of running out of funds and thus affecting your server resources."
msgstr "हम स्वचालित टॉप अप की सलाह देते हैं, क्योंकि इससे धनराशि समाप्त होने का जोखिम कम होता है और आपके सर्वर संसाधनों पर प्रभाव पड़ने की संभावना घटती है।"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "We've assembled some links to get you started. Develop, test code, and deploy your applications in no time, from prototyping to large-scale development."
msgstr "शुरू करने में आपकी मदद के लिए हमने कुछ लिंक एकत्र किए हैं। प्रोटोटाइप से लेकर बड़े पैमाने के विकास तक, तुरंत विकास करें, कोड का परीक्षण करें और अपने अनुप्रयोग परिनियोजित करें।"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "We've reached the capacity of our file browser. In order to maintain the stability of our user interface, we've terminated the loading of your bucket contents. Please utilize external tools at your disposal to manage the content within your bucket"
msgstr "हमारे फ़ाइल ब्राउज़र की क्षमता सीमा पूरी हो गई है। उपयोगकर्ता इंटरफ़ेस की स्थिरता बनाए रखने के लिए हमने आपके बकेट की सामग्री की लोडिंग रोक दी है। कृपया अपने बकेट की सामग्री प्रबंधित करने के लिए उपलब्ध बाहरी टूल्स का उपयोग करें।"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Welcome"
msgstr "स्वागत है"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Welcome!<0/>We're glad you're here."
msgstr "स्वागत है!<0/>हमें खुशी है कि आप यहाँ हैं।"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "What would you like to do?"
msgstr "आप क्या करना चाहेंगे?"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "When balance goes below"
msgstr "जब शेष राशि इससे नीचे जाए"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "When reserved but not assigned to a resource IPv4 address will be charged for <0/> / month."
msgstr "जब IPv4 पता आरक्षित हो लेकिन किसी संसाधन को असाइन न किया गया हो, तब उसके लिए <0/> / माह शुल्क लिया जाएगा।"

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "When selected, a public floating IPv4 address will be created and assigned automatically to your resource. If you do not want to have public access to your resource you can unselect the option here or remove the IP address later."
msgstr "चयन करने पर, आपके संसाधन के लिए एक सार्वजनिक फ़्लोटिंग IPv4 पता बनाया जाएगा और स्वचालित रूप से असाइन किया जाएगा। यदि आप अपने संसाधन को सार्वजनिक रूप से सुलभ नहीं बनाना चाहते हैं, तो आप यहाँ इस विकल्प का चयन हटा सकते हैं या बाद में IP पता हटा सकते हैं।"

#: src/modules/compute/VmView.tsx
msgid "When you enable the backup service, an automatic disk-level backup will be created from the boot disk (excluding additional disks). A backup will be created once a week and will be listed here. You can later use the backup images to restore your virtual machine or create a new virtual machine with modified size parameters from the backup."
msgstr "जब आप बैकअप सेवा सक्षम करते हैं, तब बूट डिस्क से स्वचालित डिस्क-स्तरीय बैकअप बनाया जाएगा (अतिरिक्त डिस्कों को छोड़कर)। सप्ताह में एक बार बैकअप बनाया जाएगा और यहाँ सूचीबद्ध होगा। बाद में आप बैकअप इमेज का उपयोग करके अपनी वर्चुअल मशीन को पुनर्स्थापित कर सकते हैं या बदले हुए आकार पैरामीटरों के साथ बैकअप से नई वर्चुअल मशीन बना सकते हैं।"

#: src/components/loading/Loading.tsx
msgid "While the job is in progress you can:"
msgstr "जब तक कार्य प्रगति पर है, आप यह कर सकते हैं:"

#: src/modules/api/resourceTypes.tsx
msgid "With a firewall you can control incoming and outgoing network traffic based on predetermined security rules."
msgstr "फ़ायरवॉल के साथ आप पूर्वनिर्धारित सुरक्षा नियमों के आधार पर आने-जाने वाले नेटवर्क ट्रैफ़िक को नियंत्रित कर सकते हैं।"

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "With first billing account you will be able to unlock your complimentary free credit of <0><1/></0>."
msgstr "पहले बिलिंग खाते के साथ आप <0><1/></0> का अपना निःशुल्क क्रेडिट अनलॉक कर सकेंगे।"

#. placeholder {0}: currency.title
#: src/modules/billing/ConversionMessage.tsx
msgid "With the selected payment method, you will be charged in {0}."
msgstr "चयनित भुगतान विधि के साथ, आपसे {0} में शुल्क लिया जाएगा।"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Without an active billing account you can not create any resources, create one to get started."
msgstr "सक्रिय बिलिंग खाते के बिना आप कोई भी संसाधन नहीं बना सकते। शुरू करने के लिए एक बनाएँ।"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Without an active billing account, resources can not be created."
msgstr "सक्रिय बिलिंग खाते के बिना संसाधन बनाए नहीं जा सकते।"

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "year"
msgstr "वर्ष"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Yearly"
msgstr "वार्षिक"

#: src/modules/disks/disk/DiskView.tsx
msgid "Yes"
msgstr "हाँ"

#: src/modules/user/ActAsModal.tsx
msgid "You are about to access user \"{name}\""
msgstr "आप उपयोगकर्ता \"{name}\" तक पहुँचने वाले हैं"

#: src/modules/access/AdminUserWarning.tsx
msgid "You are an administrator and are about to delegate your administrative privileges to another user. Please ensure this action is intentional."
msgstr "आप एक प्रशासक हैं और अपनी प्रशासनिक विशेषाधिकार किसी अन्य उपयोगकर्ता को डेलीगेट करने वाले हैं। कृपया सुनिश्चित करें कि यह कार्रवाई जानबूझकर की जा रही है।"

#: src/modules/user/ProfileView.tsx
msgid "You can activate multi-factor authentication for improved security. This works only for the username-password login method. For social login methods (Google etc.), it is usually possible to activate MFA on the third party side."
msgstr "बेहतर सुरक्षा के लिए आप मल्टी-फ़ैक्टर ऑथेंटिकेशन सक्रिय कर सकते हैं। यह केवल उपयोगकर्ता नाम-पासवर्ड लॉगिन विधि के लिए काम करता है। सोशल लॉगिन विधियों (Google आदि) के लिए आमतौर पर तृतीय-पक्ष की ओर MFA सक्रिय करना संभव होता है।"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "You can boot your virtual machine from a special image for system recovery or to install a fresh operating system. When this mode is activated, a chosen image will be attached as a boot medium. You can then use the Terminal to access your machine. This boot mode is enabled only for the current launch. Next time this virtual machine is started it will follow the normal boot routine."
msgstr "आप अपनी वर्चुअल मशीन को सिस्टम रिकवरी के लिए या नया ऑपरेटिंग सिस्टम इंस्टॉल करने के लिए किसी विशेष इमेज से बूट कर सकते हैं। जब यह मोड सक्रिय होता है, तो चुनी गई इमेज बूट माध्यम के रूप में जोड़ी जाएगी। इसके बाद आप अपनी मशीन तक पहुँचने के लिए कंसोल का उपयोग कर सकते हैं। यह बूट मोड केवल वर्तमान स्टार्टअप के लिए सक्षम होता है। अगली बार यह वर्चुअल मशीन शुरू होने पर सामान्य बूट प्रक्रिया का पालन करेगी।"

#: src/modules/billing/PaymentReturn.tsx
msgid "You can close this page."
msgstr "आप इस पृष्ठ को बंद कर सकते हैं।"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "You can create multiple billing accounts, each linked to specific payment methods. This approach allows you to effectively separate and monitor expenses across different teams, departments, or projects."
msgstr "आप कई बिलिंग खाते बना सकते हैं, जिनमें से प्रत्येक को विशिष्ट भुगतान विधियों से जोड़ा जा सकता है। इस तरीके से आप अलग-अलग टीमों, विभागों या परियोजनाओं के खर्चों को प्रभावी ढंग से अलग कर सकते हैं और उन पर नज़र रख सकते हैं।"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You can do this from here and continue it later by clicking the link in the email we send you."
msgstr "आप इसे यहाँ से कर सकते हैं और बाद में हमारे द्वारा भेजे गए ई-मेल में दिए गए लिंक पर क्लिक करके जारी रख सकते हैं।"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "You can earn and give free credits by sharing your unique referral code."
msgstr "आप अपना विशिष्ट रेफ़रल कोड साझा करके निःशुल्क क्रेडिट कमा सकते हैं और दे सकते हैं।"

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "You cannot add another reservation because a future reservation already exists."
msgstr "आप दूसरा आरक्षण नहीं जोड़ सकते, क्योंकि भविष्य का एक आरक्षण पहले से मौजूद है।"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "You commit to the full price for the selected period as soon as you confirm the reservation."
msgstr "आरक्षण की पुष्टि करते ही आप चयनित अवधि के लिए पूरी कीमत का भुगतान करने के लिए प्रतिबद्ध हो जाते हैं।"

#. placeholder {0}: ipAddress.address
#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "You have a floating IP <0>{0}</0> assigned to this resource."
msgstr "इस संसाधन को फ़्लोटिंग IP <0>{0}</0> असाइन किया गया है।"

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "You have an active campaign code (<0>{referralCode}</0>) pending to get additional bonus!"
msgstr "अतिरिक्त बोनस पाने के लिए आपका एक सक्रिय अभियान कोड (<0>{referralCode}</0>) लंबित है!"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have billing account validation in progress."
msgstr "आपका बिलिंग खाता सत्यापन प्रगति पर है।"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have completed billing account validation process. Please wait for the final decision."
msgstr "आपने बिलिंग खाता सत्यापन प्रक्रिया पूरी कर ली है। कृपया अंतिम निर्णय की प्रतीक्षा करें।"

#: src/modules/notifications/NotificationMenu.tsx
msgid "You have no notifications."
msgstr "आपके पास कोई सूचना नहीं है।"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "You may close this dialog after you have made a payment."
msgstr "भुगतान करने के बाद आप इस संवाद को बंद कर सकते हैं।"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "You may close this dialog window for now."
msgstr "आप फिलहाल इस डायलॉग विंडो को बंद कर सकते हैं।"

#: src/modules/storage/bucket/BucketView.tsx
msgid "You need to have at least one access key for browsing files in this bucket."
msgstr "इस बकेट में फ़ाइलें ब्राउज़ करने के लिए आपके पास कम से कम एक एक्सेस कुंजी होनी चाहिए।"

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is approved."
msgstr "सत्यापन स्वीकृत होने के बाद आप भुगतान विधियाँ सेट कर सकेंगे और क्लाउड सेवाओं का उपयोग कर सकेंगे।"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is complete."
msgstr "सत्यापन पूरा होने के बाद आप भुगतान विधियाँ सेट कर सकेंगे और क्लाउड सेवाओं का उपयोग कर सकेंगे।"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "You will not be charged until it is ready."
msgstr "इसके तैयार होने तक आपसे शुल्क नहीं लिया जाएगा।"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Your account has been suspended"
msgstr "आपका खाता निलंबित कर दिया गया है"

#: src/modules/billing/ConversionMessage.tsx
msgid "Your actual charge will be <0/>, with exchange rate of <1/>."
msgstr "आपसे वास्तविक शुल्क <0/> लिया जाएगा, विनिमय दर <1/> के अनुसार।"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account has been suspended. See billing account details for more information and <0>contact support</0> to resolve the issue."
msgstr "आपका बिलिंग खाता निलंबित कर दिया गया है। अधिक जानकारी के लिए बिलिंग खाते का विवरण देखें और समस्या के समाधान के लिए <0>सहायता से संपर्क करें</0>।"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Your billing account has been topped up"
msgstr "आपका बिलिंग खाता टॉप अप हो गया है"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account must have positive balance to get activated."
msgstr "सक्रिय होने के लिए आपके बिलिंग खाते में धनात्मक शेष राशि होनी चाहिए।"

#: src/modules/login/Login.tsx
msgid "Your email address has been successfully verified. You can now log in."
msgstr "आपका ईमेल पता सफलतापूर्वक सत्यापित हो गया है। अब आप लॉग इन कर सकते हैं।"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Your email address has changed since you started validation. Please start over."
msgstr "सत्यापन शुरू करने के बाद आपका ईमेल पता बदल गया है। कृपया प्रक्रिया फिर से शुरू करें।"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Your selected billing account has {discount}% discount"
msgstr "आपके चुने हुए बिलिंग खाते पर {discount}% छूट है"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Your storage bucket contains a substantial number of files, and we've temporarily halted the loading process. Simply click the \"Load More\" button to continue loading the next batch of files."
msgstr "आपके स्टोरेज बकेट में काफ़ी बड़ी संख्या में फ़ाइलें हैं, इसलिए हमने लोडिंग प्रक्रिया को अस्थायी रूप से रोक दिया है। फ़ाइलों के अगले बैच को लोड करना जारी रखने के लिए बस \"और लोड करें\" बटन पर क्लिक करें।"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Zip/postal code"
msgstr "ज़िप/डाक कोड"
